import
{
    Component,
    Input,
    Output,
    Inject,
    OnInit,
    OnDestroy,
    EventEmitter,
    ViewChild,
    LOCALE_ID,
    TemplateRef,
    ViewChildren,
    QueryList,
    ElementRef,
    ViewContainerRef,
    AfterViewChecked,
    AfterViewInit,
    ChangeDetectorRef,
    NgZone,
    Signal,
    computed,
    signal,
    WritableSignal
} from "@angular/core";
import { BehaviorSubject, Observable, Subject, Subscription, fromEvent } from "rxjs";
import { debounceTime, takeUntil, } from "rxjs/operators";
import
{
    IgxGridComponent,
    GridPagingMode,
    NoopFilteringStrategy,
    NoopSortingStrategy,
    IgxGridStateDirective,
    IGridEditEventArgs,
    IFilteringStrategy,
    IGridStateOptions,
    FilteringLogic,
    IgxColumnComponent,
    IgxGridCell,
    IgxGridToolbarComponent,
    IGridToolbarExportEventArgs,
    IgxDropDownComponent,
    IColumnExportingEventArgs,
    IFilteringExpressionsTree,
    IGridCellEventArgs,
    IGridState,
    IRowSelectionEventArgs,
    IgxBooleanFilteringOperand,
    IActiveNodeChangeEventArgs,
    FilteringStrategy,
    IgxExcelExporterOptions,
    IgxExcelExporterService,
    IgxCsvExporterOptions,
    CsvFileTypes,
    IgxCsvExporterService,
    ISortingStrategy,
    IColumnPipeArgs,
    IRowExportingEventArgs,
    IGridKeydownEventArgs,
    IGridScrollEventArgs,
    IPinColumnEventArgs,
    CellType
} from "@infragistics/igniteui-angular";
import { IMenuOption, IPaginatorChangeEventData } from "@tylertech/forge";
import { Utilities } from "@tylertech/shared-module";
import { Command, LabelCommand } from "@tylertech/commands-module";
import { CachedRepositoryService, FeatureFlagHelperService, OmniBarService, SecurityService } from "@tylertech/core-module";
import { KeyHandlerService } from "@tylertech/core-module";
import { CommonDialogsService } from "@tylertech/common-dialogs-module";
import
{
    IMetadataAction,
    IGridViewMetadata,
    GridEditType,
    SelectionMode,
    MetadataSummary,
    ClassMetadata,
    Key,
    ModifierKey,
    MetadataAction,
    PropertyMetadata
} from "@tylertech/tyler-api-types";
import { RowCommandArgs, TableRowSelectArgs, RepositoryFormData, RowCommandRow, AugmentedModelObject } from "../../../interfaces";
import
{
    GridFormatService,
    GridActionService,
    InfoGridLayoutService,
    GridMetadataService,
    GridSelectionService,
    CellEditService,
    CellEditCommandService,
    MetadataService,
    MetadataActionService,
    MetadataEventService,
    MetadataTableService,
    MetadataViewService,
    GridLoadService,
    MetadataInputTypeHelperService,
    MultipleEntityEditService,
    GridSelectionEventArg,
    ProviderStorageService,
    GridFilterService,
    MetadataPropertyService,
    GridValidationService,
    GridDeleteService,
    MetadataTableEventArg,
    GridEventService
} from "../../../services";
import { Summary, CurrencySummary, Average, CurrencyAverage } from "./summary";
import { CellEditOverlay } from "./cellEditOverlay.component";
import { formatDate } from "@angular/common";
import { MetadataActionHelpers } from "../../../utilities";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";

export interface GridRowSetting
{
    UserId: string;
    Title: string;
    Path: string;
    Rows: number;
}

interface SummarySetting
{
    HasSummary: boolean;
    SummaryType: MetadataSummary;
}

interface CellState
{
    isDisabled: boolean;
    getIcon?: string;
    useIconSpan?: boolean;
    isHidden?: boolean;
}

@Component({
    selector: "info-grid",
    templateUrl: "./infoGrid.tmpl.html",
    standalone: false
})
export class InfoGridComponent implements OnInit, AfterViewInit, OnDestroy, AfterViewChecked
{
    @Input()
    rowsPerPage: number;

    @Input()
    multipleEdit: boolean;

    @Input()
    displayHeader: boolean;

    @Input()
    displayFooter: boolean;

    @Input()
    displayTable: boolean;

    @Input()
    useRepository: boolean;

    @Input()
    noFilter: boolean;

    @Input()
    hideHeaderCheckbox: boolean;

    @Input()
    hideHeaderSelections: boolean;

    @Input()
    metadataServerPaging: boolean;

    @Input()
    viewMetadata: IGridViewMetadata;

    @Input()
    model: any;

    @Input()
    datacontroller: RepositoryFormData;

    @Input()
    disableViewAction: boolean;

    @Input()
    spaceForFab: boolean;

    @Input()
    parentView: string;

    @Input() isStepperGrid: boolean;

    @Input() disableGridAdd: boolean = false;

    @Output()
    repositoryFunction = new EventEmitter<RowCommandArgs>();

    @Output()
    onSelected = new EventEmitter<TableRowSelectArgs>();

    @ViewChild("grid")
    grid: IgxGridComponent;

    @ViewChild("toolbar")
    toolbar: IgxGridToolbarComponent;

    @ViewChild("gridLayoutDropdown")
    gridLayoutDropdown: IgxDropDownComponent;

    @ViewChild("exportDropdown")
    exportDropdown: IgxDropDownComponent;

    @ViewChildren("booleanTemplate")
    booleanTemplate: QueryList<TemplateRef<any>>;

    @ViewChildren("actionTemplate")
    actionTemplate: QueryList<TemplateRef<any>>;

    @ViewChildren("actionCurrencyTemplate")
    actionCurrencyTemplate: QueryList<TemplateRef<any>>;

    @ViewChildren("actionNumberTemplate")
    actionNumberTemplate: QueryList<TemplateRef<any>>;

    @ViewChildren("actionPercentTemplate")
    actionPercentTemplate: QueryList<TemplateRef<any>>;

    @ViewChildren("actionDateTemplate")
    actionDateTemplate: QueryList<TemplateRef<any>>;

    @ViewChildren("actionDateTimeTemplate")
    actionDateTimeTemplate: QueryList<TemplateRef<any>>;

    @ViewChildren("actionTimeTemplate")
    actionTimeTemplate: QueryList<TemplateRef<any>>;

    @ViewChildren("iconTemplate")
    iconTemplate: QueryList<TemplateRef<any>>;

    @ViewChildren("dateTemplate")
    dateTemplate: QueryList<TemplateRef<any>>;

    @ViewChildren("dateTimeTemplate")
    dateTimeTemplate: QueryList<TemplateRef<any>>;

    @ViewChildren("timeTemplate")
    timeTemplate: QueryList<TemplateRef<any>>;

    @ViewChildren("numberTemplate")
    numberTemplate: QueryList<TemplateRef<any>>;

    @ViewChildren("currencyTemplate")
    currencyTemplate: QueryList<TemplateRef<any>>;

    @ViewChildren("percentTemplate")
    percentTemplate: QueryList<TemplateRef<any>>;

    @ViewChild("cellEditTemplate")
    cellEditTemplate: TemplateRef<any>;

    @ViewChildren("docLookupTemplate")
    docLookupTemplate: QueryList<TemplateRef<any>>;

    @ViewChild(IgxGridStateDirective, { static: true })
    public state: IgxGridStateDirective;

    @ViewChild("cellEditInput")
    private cellEditInput: ElementRef;

    public options: IGridStateOptions = {
        columns: true,
        filtering: true,
        advancedFiltering: true,
        sorting: true,
        cellSelection: false,
        rowSelection: false,
        columnSelection: false,
        paging: false,
        groupBy: false,
        expansion: false,
        rowPinning: false,
        moving: false
    };

    public filterStrategy: IFilteringStrategy;

    get sortStrategy(): ISortingStrategy
    {
        if (this.isGroupedGrid)
            return undefined;
        return NoopSortingStrategy.instance();
    }

    private readonly destroy$ = new Subject<void>();

    private afterFetchCallback: (() => void) | null = null;

    private contextMenuHandlers = new WeakMap<HTMLElement, EventListener>();

    providerId: string;

    loadFailed: boolean = false;

    loadFailedMessage: string;

    commands: Array<Command> = [];

    selectionMode: string = "none";

    fetching: boolean = true;

    restoringLayout: boolean = false;

    grouping: boolean = false;

    runRecalculate: boolean = false;

    layoutLoading: boolean = false;

    clearSkipLayout: boolean = false;

    initialized: boolean = false;

    refreshAction: boolean = false;

    showToolbar: boolean = false;

    public page = 0;

    public perPage: number = 0;

    public totalCount = 0;

    public data: Observable<any[]>;

    public remoteData: BehaviorSubject<any[]>;

    private _prevRequest: Subscription;

    public columns: any[];

    public mode = GridPagingMode.Remote;

    delayUpdate: boolean = false;

    cellEditModel: any;

    cellEditMetadata: ClassMetadata;

    public selectOptions = [
        5, 15, 25, 50, 100
    ];

    tableOptionsOpen: boolean = true;

    currentEditCellOriginalModelValue: any;

    currentEditCellOriginalDisplayValue: any;

    currentEditCellPropertyName: string;

    recalculatedDuringEdit: boolean;

    initialWidths: Record<string, string> = {};

    checkForLayout: boolean = true;

    layoutLoaded: boolean;

    summarySetup: Record<string, SummarySetting> = {};

    public summary = Summary;

    public currencySummary = CurrencySummary;

    public average = Average;

    public currencyAverage = CurrencyAverage;

    private readonly recalculating: WritableSignal<boolean> = signal(false);

    private readonly runCheckboxEdit = signal<(() => void) | null>(null);

    isAdding: boolean = false;

    hidePaginator: boolean;

    editFirstCellAfterAdd: boolean = false;

    cellEditAddWaitForRecalculate: boolean = false;

    cellEditNextEditableEnabledChange: boolean = false;

    allowShowRecent: boolean;

    gridOverwritesCompleted = false;

    holdScrollPosition: boolean;

    tabbedViewGrid: boolean;

    alternateGridLines = false;

    private modelsToDelete: any[];

    private isDeleteRetrying: boolean = false;

    private indexToDelete: number;

    cellClasses: any;

    canAdd: boolean = false;
    hasSelection: boolean = false;
    allowSort: boolean = false;

    private devFlagOn: boolean = false;

    readonly columnValuesStrategy: (
        column: IgxColumnComponent,
        columnExprTree: IFilteringExpressionsTree,
        done: (uniqueValues: any[]) => void
    ) => void;

    public clipboardOptions = {
        enabled: true,
        copyHeaders: false,
        copyFormatters: true,
        separator: '\t'
    };


    constructor(
        private cdr: ChangeDetectorRef,
        private ngZone: NgZone,
        private csvExportService: IgxCsvExporterService,
        private excelExportService: IgxExcelExporterService,
        private $featureFlagHelperService: FeatureFlagHelperService,
        private $repositoryService: CachedRepositoryService,
        private $omniBarService: OmniBarService,
        private $commonDialogsService: CommonDialogsService,
        private readonly $metadataViewService: MetadataViewService,
        private readonly $metadataService: MetadataService,
        private $metadataActionService: MetadataActionService,
        private $metadataEventService: MetadataEventService,
        private $gridEventService: GridEventService,
        private $metadataTableService: MetadataTableService,
        private $providerStorageService: ProviderStorageService,
        private $metadataInputTypeHelperService: MetadataInputTypeHelperService,
        @Inject(LOCALE_ID)
        public locale: string,
        private $securityService: SecurityService,
        private readonly $metadataPropertyService: MetadataPropertyService,
        private $multipleEntityEditService: MultipleEntityEditService,
        private $gridMetadataService: GridMetadataService,
        private $gridFormatService: GridFormatService,
        private $gridLoadService: GridLoadService,
        private $gridLayoutService: InfoGridLayoutService,
        private $gridActionService: GridActionService,
        private $gridSelectionService: GridSelectionService,
        private $gridFilterService: GridFilterService,
        private $gridDeleteService: GridDeleteService,
        private $cellEditService: CellEditService,
        private $gridValidationService: GridValidationService,
        private $cellEditCommandService: CellEditCommandService,
        private $keyHandlerService: KeyHandlerService,
        private viewContainerRef: ViewContainerRef
    )
    {
        this.remoteData = new BehaviorSubject([]) as any;

        this.ngZone.runOutsideAngular(() =>
        {
            fromEvent(window, "resize", { passive: true })
            .pipe(debounceTime(150), takeUntilDestroyed())
            .subscribe(() => this.setGridHeight());
        });

        this.columnValuesStrategy = this.columnValuesStrategyImpl.bind(this);

        //Setting this here to avoid multiple calls and dev flag may be common in this component
        this.devFlagOn = this.$featureFlagHelperService.isDevFlagOn;

        this.$gridDeleteService.deleteRetry.pipe(takeUntilDestroyed()).subscribe(() => this.processNextDelete());

        this.registerListeners();
    }

    private readonlyCellCache = new Map<string, boolean>();

    setCellClasses():void
    {
        this.readonlyCellCache.clear();
        this.cellClasses = {
            'invalid-cell': this.invalidCellCondition,
            'readonly-cell': this.readOnlyCellEditCell
        };
    }

    private invalidCellCondition = (rowData: any, columnKey: any): boolean =>
    {
        return rowData["$$model"]["$cellEditInvalidProperties"]?.filter(p => p === columnKey)?.length > 0;
    };

    private readOnlyCellEditCell = (rowData: any, columnKey: string): boolean =>
    {
        if(!this.isGridCellEdit)
            return false;
        const cacheKey = `${rowData.Id}|${columnKey}`;
        const cached = this.readonlyCellCache.get(cacheKey);
        if (cached !== undefined)
            return cached;
        const cell = this.grid.getCellByKey(rowData.Id, columnKey);
        const viewOnly = this.$cellEditService.ViewOnlyCell(cell, this.grid, this.$providerStorageService.GridData[this.providerId], this.viewMetadata, this.columns);
        this.readonlyCellCache.set(cacheKey, viewOnly);
        return viewOnly;
    };

    ngAfterViewChecked(): void
    {
        if (!this.gridOverwritesCompleted)
        {
            let button = document.querySelector("igx-grid-toolbar-pinning button");
            if (!Utilities.IsNullOrUndefined(button))
            {
                this.gridOverwritesCompleted = true;

                button.setAttribute("tabindex", "-1");

                button = document.querySelector("igx-grid-toolbar-hiding button");
                button.setAttribute("tabindex", "-1");

                const self = this;
                const gridBody = document.querySelector(".igx-grid__tbody-content");

                fromEvent(gridBody, "blur")
                    .pipe(takeUntil(self.destroy$))
                    .subscribe(() =>
                    {
                        self.grid.clearCellSelection();
                    });


                const footer = document.querySelector(".igx-grid__tfoot div");
                if (footer)
                {
                    footer.removeAttribute("tabindex");
                }

                const scroll = document.querySelector("igx-virtual-helper.igx-vhelper--vertical");
                if (scroll)
                {
                    scroll.setAttribute("tabindex", "-1");
                }
            }
        }
    }

    ngOnInit(): void
    {
        this.providerId = this.viewMetadata.GridProperties["$providerId"];
        if (this.isGroupedGrid)
            this.metadataServerPaging = false;
        this.$providerStorageService.InfiniteScroll[this.providerId] = !this.metadataServerPaging;
        this.perPage = this.infiniteScroll ? 50 : (Utilities.IsNullOrUndefinedOrZero(this.rowsPerPage) ? this.getDefaultRowsPerPage() : this.rowsPerPage);
        requestAnimationFrame(() => this.setFilterStrategy());
        if (Utilities.IsNullOrUndefined(this.displayHeader)) this.displayHeader = true;
        if (Utilities.IsNullOrUndefined(this.displayTable)) this.displayTable = true;
        if (!Utilities.IsNullOrUndefinedOrZero(this.rowsPerPage) && this.selectOptions.indexOf(this.rowsPerPage) < 0)
        {
            this.selectOptions.push(this.rowsPerPage);
        }
        this.data = this.remoteData.asObservable();
        this.tableOptionsOpen = !this.viewMetadata.GridProperties.CloseOptionsDefault;
        this.allowShowRecent = this.$gridLoadService.allowShowRecent(this.viewMetadata) && this.$gridLoadService.hasRecent(this.viewMetadata.GridId) && !this.recentLoaded;

        if (this.$metadataViewService.IsCellEditGrid(this.viewMetadata))
        {
            this.$gridValidationService.validateCellGrid.pipe(takeUntil(this.destroy$)).subscribe(() =>
            {
                this.$gridValidationService.validateCellEditGrid(this.providerId, this.viewMetadata, this.cellEditing);
                this.grid.markForCheck();
            });
        }

        this.alternateGridLines = this.$securityService.UseAlternatingGridLines;
    }

    registerListeners(): void
    {
        const self = this;

        self.$metadataEventService.onRecalculateWorking.pipe(takeUntilDestroyed())
            .subscribe(args =>
            {
                self.recalculating.set(args.Recalculating);

                let model = self.datacontroller.Entity;
                if (self.viewMetadata.SubPropertyType && self.datacontroller.OtherEntities[self.viewMetadata.SubPropertyType])
                    model = self.datacontroller.OtherEntities[self.viewMetadata.SubPropertyType][0];

                if (self.cellEditing && !self.recalculating() && self.viewMetadata.SubPropertyName)
                {
                    const row = model[self.viewMetadata.SubPropertyName][self.currentRowIndex];
                    if (row)
                    {
                        const newValue = row[self.currentEditCellPropertyName];
                        if (newValue !== self.currentEditCellOriginalModelValue)
                        {
                            self.currentEditCellOriginalModelValue = newValue;
                            self.recalculatedDuringEdit = true;
                        }
                    }
                    else
                        self.endCellEditFinal();
                }

                if (!self.recalculating())
                {
                    self.$gridValidationService.validateCellEditGrid(self.providerId, self.viewMetadata, self.cellEditing);
                    const fn = this.runCheckboxEdit();
                    if (fn)
                    {
                        this.runCheckboxEdit.set(null);
                        fn();
                    }
                }

                if (!self.cellEditAddWaitForRecalculate)
                    return;

                self.cellEditAddWaitForRecalculate = false;

                self.viewMetadata.GridProperties.CanAdd = self.$metadataService.GetPermission(
                    self.viewMetadata.GridProperties["$InitialCanAdd"],
                    self.viewMetadata.CanAddProperty,
                    model
                );
                self.canAdd = self.viewMetadata.GridProperties.CanAdd;
                if (self.$cellEditService.IsLastEditableColumn(self.grid, self.viewMetadata, self.currentRowIndex, self.currentColumnIndex) && self.viewMetadata.GridProperties.CanAdd)
                    self.addItem(false);
                else
                    self.cellEditNextEditableEnabledChange = true;
            });


        this.$gridEventService.onUpdateProjectionGrid.pipe(takeUntilDestroyed())
            .subscribe(projectionArg =>
            {
                if (projectionArg.ProviderId === self.providerId)
                    self.$gridLoadService.UpdateProjectionTableEntity(projectionArg.ProviderId, projectionArg.Entities, self.grid, self.viewMetadata, self.page, self.perPage)
                        .then(() =>
                        {
                            self.$providerStorageService.BuildSummaries[self.providerId] = true;
                            requestAnimationFrame(()=> self.afterFetch(false, false, false));
                        });
            });

        this.$gridEventService.onTableEntityChanged.pipe(takeUntilDestroyed())
            .subscribe(provider =>
            {
                if (provider === self.providerId)
                {
                    self.summarySetup = {};
                    self.fetching = true;
                    self.$cellEditService.ViewOnly = {};
                    if (!self.isGridCellEdit)
                    {
                        self.resetScrollPosition();
                    }

                    const initial = self.grid.data.length === 0 || self.$providerStorageService.ApplyFilter[self.providerId] || self.$providerStorageService.ClearFilter[self.providerId];

                    self.fetch(initial, false, true, true);
                }
            });

        this.$gridEventService.onTableLoadingFinished.pipe(takeUntilDestroyed())
            .subscribe(provider =>
            {
                if (provider === self.providerId)
                {
                    self.fetching = false;
                    self.cellEditing = false;
                    self.isAdding = false;
                }
            });

        this.$gridEventService.onFetchTable.pipe(takeUntilDestroyed())
            .subscribe(() =>
            {
                self.fetching = true;
                self.fetch(true, false, true);
            });

        this.$gridEventService.onUpdateGridSelection.pipe(takeUntilDestroyed())
            .subscribe((arg: GridSelectionEventArg) =>
            {
                if (arg.Clear)
                {
                    self.$gridSelectionService.SetSelectedIds(arg.ProviderId, []);
                }
                else if (arg.ProviderId === self.providerId)
                {
                    self.$gridSelectionService.SetSelected(
                        self.providerId,
                        self.grid,
                        true,
                        self.viewMetadata,
                        self.$gridSelectionService.AllSelected,
                        self.$gridSelectionService.AllDeselected
                    );
                }
            });
        this.$gridEventService.onGridResize.pipe(takeUntilDestroyed())
            .subscribe(() =>
            {
                setTimeout(() => self.setGridHeight(), 250);
            });

        this.$gridEventService.onCellEditOnAdd.pipe(takeUntilDestroyed())
            .subscribe(providerId =>
            {
                if (providerId === self.providerId)
                    self.cellAdding = true;
            });

        this.$gridLoadService.onModelChanged.pipe(takeUntilDestroyed())
            .subscribe(() =>
            {
                self.computeAllCellStates();
            });
    }

    public ngAfterViewInit(): void
    {
        if (Utilities.IsNullOrUndefined(this.displayTable)) this.displayTable = true;
        if (Utilities.IsNullOrUndefined(this.displayFooter)) this.displayFooter = false;
        if (this.viewMetadata)
        {
            //Reset viewMetadata $$cellEditing if the user managed to leave the grid without exiting edit mode.  Hopefully not a long term problem
            this.viewMetadata["$$cellEditing"] = this.cellEditing;
            this.tabbedViewGrid = this.viewMetadata["$tabbedViewGrid"];
            this.cdr.detectChanges();
        }
        if (this.viewMetadata && this.viewMetadata["$projectionGridUpdatingEntity"])
        {
            this.viewMetadata["$columns"] = this.$gridLoadService.defineColumns(
                [this.viewMetadata["$projectionGridUpdatingEntity"]],
                this.viewMetadata,
                this.metadataServerPaging
            );

            this.$gridLoadService.UpdateProjectionTableEntity(this.providerId, [this.viewMetadata["$projectionGridUpdatingEntity"]], this.grid, this.viewMetadata, this.page, this.perPage)
                .then(() => this.fetch(true, false, true));
        }
        else
            this.fetch(true, false, true);
        this.grid.filteringExpressionsTreeChange.pipe(debounceTime(300), takeUntil(this.destroy$))
            .subscribe(() =>
            {
                this.$gridLoadService.FilterChanged[this.providerId] = true;
                this.fetching = true;
                this.runRecalculate = true;
                this.$gridSelectionService.AllSelected = false;
                this.$gridSelectionService.AllDeselected = false;
                if (!this.layoutLoading) this.page = 0;
                this.layoutLoading = false;
                this.$gridSelectionService.Selecting = false;
                setTimeout(() => this.fetch(false, false, true), 50); //timeout is sadly needed because grid load will block showing fetch spinner
            });
        this.grid.sortingExpressionsChange.pipe(debounceTime(300), takeUntil(this.destroy$))
            .subscribe(() =>
            {
                this.$gridLoadService.FilterChanged[this.providerId] = true;
                if (this.skipSort)
                    return;
                this.fetching = true;
                this.$gridSelectionService.Selecting = false;
                this.fetch(false, false, true);
            });
        this.grid.dataPreLoad.pipe(takeUntil(this.destroy$))
            .subscribe(($event) =>
            {
                if (!this.infiniteScroll || this.fetching || this.$gridLoadService.Scrolling[this.providerId] || this.grid.groupingResult?.length > 0)
                    return;
                const scrollDown = this.scrollStartIndex < $event.startIndex;
                this.scrollStartIndex = $event.startIndex;
                const isLastChunk = (this.grid.virtualizationState.startIndex + this.grid.virtualizationState.chunkSize) >= (this.$providerStorageService.GridData[this.providerId].length);
                if (scrollDown && isLastChunk)
                    this.handlePreLoadImpl();
            });
        this.grid.groupingExpressionsChange.pipe(takeUntil(this.destroy$))
            .subscribe(() =>
            {
                if (this.fetching || this.entireGridLoaded || this.restoringLayout)
                    return;
                this.grouping = true;
                this.fetching = true;
                this.$gridSelectionService.Selecting = false;
                this.page = 0;
                this.perPage = this.totalCount;
                this.fetch(false, false, true);
                this.entireGridLoaded = true;
            });
        this.grid.groupingDone.pipe(takeUntil(this.destroy$)).subscribe(() => this.grouping = false);
    }

    scrollStartIndex: number = 0;
    entireGridLoaded: boolean = false;

    getDefaultRowsPerPage(): number
    {
        if (this.$securityService.principle.RowsPerPage)
            return this.$securityService.principle.RowsPerPage;
        return 25;
    }

    get combinedViewTable(): boolean
    {
        return this.viewMetadata["$combinedViewTable"];
    }

    setPaginatorVisibility(): void
    {
        this.hidePaginator = !this.infiniteScroll && !this.viewMetadata["$fixedHeight"] && this.totalCount < 15 && this.totalCount < this.perPage;

        const paginator = document.querySelector("igx-paginator-content forge-paginator")?.shadowRoot.querySelectorAll("forge-icon-button");
        if (paginator)
        {
            paginator.forEach(button => button.setAttribute("dense", "true"));
        }
    }

    setGridHeight(): void
    {
        const minMaxHeight = 400;
        let isDialogGrid = false;

        if(this.tabbedViewGrid)
        {
            let parent: HTMLElement = document.querySelector(".dialog-content");
            if(Utilities.IsNullOrUndefined(parent))
            {
                parent = document.querySelector(`#${this.parentView}`) as HTMLElement;
            }

            const childViews = parent.querySelectorAll(".combined-view--view:not(.combined-view--table-view)");
            const padding = 32;

            setTimeout(() => {
                let siblingsHeight = 0;
                childViews.forEach(child => {
                    if(child.querySelectorAll("forge-tab-bar").length === 0)
                    {
                        siblingsHeight += Math.ceil(child.getBoundingClientRect().height);
                    }
                });

                const tabBar = parent.querySelector("forge-tab-bar");
                if(!Utilities.IsNullOrUndefined(tabBar))
                {
                    siblingsHeight += tabBar.getBoundingClientRect().height;
                }

                const toolBar = parent.querySelector("forge-toolbar");
                if(!Utilities.IsNullOrUndefined(toolBar))
                {
                    siblingsHeight += toolBar.getBoundingClientRect().height;
                }

                let newHeight = parent.clientHeight - siblingsHeight - padding;
                if(newHeight < minMaxHeight)
                {
                    newHeight = minMaxHeight;
                }
                this.grid.nativeElement.parentElement.style.height = `${newHeight}px`;
            }, 100);

            return;
        }

        if (this.combinedViewTable)
        {
            let parent: HTMLElement = document.querySelector(".dialog-content");
            if(Utilities.IsNullOrUndefined(parent))
            {
                parent = document.querySelector(`#${this.parentView}`) as HTMLElement;
            }
            else
            {
                isDialogGrid = true;
            }

            let tabPanelHeight = 0;

            if (!Utilities.IsNullOrUndefined(parent))
            {
                const childViews = parent.querySelectorAll(".combined-view--view:not(.combined-view--table-view)");
                const padding = 32;

                const tables = parent.querySelectorAll(".combined-view--table-view");

                if (onlyOneValidTable(tables) || this.isGridCellEdit)
                {
                    setTimeout(() =>
                    {
                        let siblingsHeight = 0;
                        childViews.forEach(child =>
                        {
                            if (child.querySelectorAll(".forge-view-switcher__view--hidden").length === 0)
                            {
                                siblingsHeight += Math.ceil(child.getBoundingClientRect().height);
                            }
                            else
                            {
                                if (tabPanelHeight === 0)
                                {
                                    tabPanelHeight = parent.querySelector("forge-tab-bar").clientHeight;
                                }
                            }
                        });

                        if (siblingsHeight === 0)
                        {
                            const header = parent.querySelector("forge-toolbar");
                            if (header)
                            {
                                siblingsHeight = header.clientHeight;
                            }
                        }

                        let newHeight = parent.clientHeight - siblingsHeight - padding - tabPanelHeight;
                        if (newHeight < minMaxHeight)
                        {
                            newHeight = minMaxHeight;
                        }
                        this.grid.nativeElement.parentElement.style.height = `${newHeight}px`;
                    }, 100);
                }
                else
                {
                    const primaryViewWidth = document.querySelector("metadata-view")?.clientWidth;

                    if((isDialogGrid && tables.length > 1) || this.grid.nativeElement.clientWidth <= primaryViewWidth / 2)
                    {
                        this.grid.nativeElement.parentElement.style.height = "100%";
                        this.grid.nativeElement.parentElement.style.maxHeight = "400px";
                    }
                    else
                    {
                        const rowHeight = this.grid.rowHeight + 1; //Add 1 for padding
                        const rowCount = this.grid.totalRowsCountAfterFilter + 1; //Add 1 for header row
                        const summaryRowHeight = this.grid.summaryRowHeight;
                        const headerPadding = 48;
                        const scrollPadding = 20;
                        const footerPadding = 44;

                        let newHeight = rowHeight * rowCount + summaryRowHeight + headerPadding + scrollPadding + footerPadding;

                        if(newHeight > minMaxHeight)
                        {
                            newHeight = minMaxHeight;
                        }

                        this.grid.nativeElement.parentElement.style.height = `${newHeight}px`;
                    }
                }
            }
        }
        else if(this.isStepperGrid)
        {
            const parent: HTMLElement = document.querySelector(`#${this.parentView}`).parentElement.parentElement.parentElement as HTMLElement;

            if (!Utilities.IsNullOrUndefined(parent))
            {
                const padding = 32;
                setTimeout(() =>
                {
                    let newHeight = parent.clientHeight - padding;
                    if (newHeight < minMaxHeight)
                    {
                        newHeight = minMaxHeight;
                    }
                    this.grid.nativeElement.parentElement.style.height = `${newHeight}px`;
                }, 100);
            }
        }
        else
        {
            this.grid.nativeElement.parentElement.style.height = "100%";
        }

        function onlyOneValidTable(tables: NodeListOf<Element>): boolean
        {
            let tableCount = 0;

            tables.forEach(table => {
                if(table.clientHeight > 0)
                {
                    tableCount++;
                }
            });

            return tableCount === 1;
        }
    }

    setFilterStrategy(): void
    {
        if (this.metadataServerPaging) this.filterStrategy = NoopFilteringStrategy.instance();
        else this.filterStrategy = FilteringStrategy.instance();
    }

    paginate($event: IPaginatorChangeEventData): void
    {
        if (this.fetching || (this.page === $event.pageIndex && this.perPage === $event.pageSize)) return;
        this.resetScrollPosition();
        this.fetching = true;
        this.$gridSelectionService.Selecting = false;
        this.cellEditing = false;
        this.grid.crudService.endEditMode();
        this.grid.clearCellSelection();
        this.grid.deselectAllRows(false);
        this.page = $event.pageIndex;
        this.perPage = $event.pageSize;
        this.fetch();
    }

    ngOnDestroy(): void
    {
        if (this._prevRequest)
        {
            this._prevRequest.unsubscribe();
        }
        this.remoteData.complete();
        this.destroy$.next();
        this.destroy$.complete();
        this.exitCellEdit();
        this.firstLayoutLoadFromCache = true;
        this.cacheLocalGridLayout(false);
        this.$keyHandlerService.unsubscribe(Key.A, ModifierKey.Alt);
        this.activeNodeChange(null);
        this.afterFetchCallback = null;
        this.summarySetup = {};
        this.grid.data = [];
    }

    doRepositoryFunction(command: string, row: RowCommandRow): void
    {
        if (this.isGridCellEdit && command === "Edit")
        {
            this.$cellEditService.EditFirstCell(this.grid, this.viewMetadata, this.grid.getRowByKey(row.id).index, true);
            return;
        }
        this.cacheLocalGridLayout(true);
        if (command === "EditMultiple") this.viewMetadata["$multipleEdit"] = true;

        if (command === "Delete")
            this.viewMetadata["$$Deleting"] = true;
        if (command === "Delete" || command === "Edit")
            this.clearSkipLayout = true;
        if (this.$metadataViewService.IsProjectionGrid(this.viewMetadata) && command === "EditMultiple")
        {
            let editEntity: any;
            if (!this.viewMetadata.EditAction)
                editEntity = this.$multipleEntityEditService.EditableEntities[this.$multipleEntityEditService.CurrentEditIndex];
            else
                editEntity = this.$multipleEntityEditService.editActionEntity;
            if (editEntity)
            {
                const idProperty = this.viewMetadata["GridProperties"].IdProperty;
                const entity = {};
                entity[idProperty] = editEntity[idProperty];
                this.datacontroller["$$ProjectionGridEntity"] = entity;
            }
        }

        this.repositoryFunction.emit(<RowCommandArgs>{
            command: command,
            row: row,
        });
    }

    cacheLocalGridLayout(editClick: boolean): void
    {
        if ((!editClick && this.$multipleEntityEditService.ProviderId) || this.totalCount === 0)
            return;
        this.saveGridState(true);
    }

    restoreLocalGridLayout(): void
    {
        if (this.$multipleEntityEditService.ProviderId === this.providerId) return;
        requestAnimationFrame(() => this.loadGridState(true));
    }

    resetScrollPosition(): void
    {
        this.$gridLayoutService.ScrollPosition[this.providerId] = "0";
    }

    handlePreLoadImpl(): void
    {
        this.$gridLoadService.Scrolling[this.providerId] = true;
        this.holdScrollPosition = true;
        this.fetching = true;
        this.$gridSelectionService.Selecting = false;
        this.page = 0;
        this.perPage = this.perPage + 25;
        this.fetch();
    }

    fetch(initial: boolean = false, loadRecent: boolean = false, buildColumnSummaries: boolean = false, fromRecalculate: boolean = false): void
    {
        const self = this;
        if (!this.$gridLoadService.Scrolling[this.providerId] && this.$providerStorageService.LocalEntitiesStore[this.providerId] && !this.entireGridLoaded)
            this.$providerStorageService.LocalEntitiesStore[this.providerId].forEach(x => x["$processed"] = false);
        self.$providerStorageService.BuildSummaries[this.providerId] = buildColumnSummaries;

        this.$providerStorageService.IsDataLoading[this.viewMetadata.GridProperties["$providerId"]] = true;
        if (initial && !this.$gridSelectionService.RowSelectRecalculate && !this.$providerStorageService.SkipLayout[this.viewMetadata.GridProperties["$providerId"]])
            this.page = 0;
        if (this.page > 0 && this.$providerStorageService.GridData[this.providerId]?.filter(x => !x["$$Deleting"]).length === 0)
            this.page--;
        this.$gridSelectionService.RowSelectRecalculate = false;
        const skip = this.page * this.perPage;
        const applyPaging = true;
        const forExport = this.model?.$forExport;
        if (this.model)
            this.model.$forExport = false;
        if (initial && this.viewMetadata)
            this.$gridLoadService.InitialSortDone[this.viewMetadata.GridProperties["$providerId"]] = false;

        let scrollPosition = parseInt(this.$gridLayoutService.ScrollPosition[this.providerId] ?? "0");
        if (this.infiniteScroll && scrollPosition > 0)
            this.perPage = this.perPage + scrollPosition;

        this._prevRequest = this.$gridLoadService.getData(
            this.grid,
            this.model,
            this.viewMetadata,
            this.metadataServerPaging,
            applyPaging && !forExport,
            _applyPaging => this.afterFetch(initial, loadRecent, fromRecalculate),
            forExport ? null : skip,
            forExport ? null : this.perPage,
            forExport ? null : this.skipSort,
            forExport ? null : loadRecent
        );
    }

    afterFetch(initial: boolean, loadRecent: boolean, fromRecalculate: boolean): void
    {
        const self = this;
        self.$providerStorageService.IsDataLoading[self.viewMetadata.GridProperties["$providerId"]] = false;
        const gridData = self.$providerStorageService.GridData[self.viewMetadata.GridProperties["$providerId"]];
        if (gridData && gridData.length > 0)
        {
            if (self.model)
            {
                const parent = self.model["$isEntityWrapper"] ? self.model["$value"] : self.model;
                for (const row of gridData)
                {
                    const childModel = row["$$model"];
                    if (Utilities.IsNullOrUndefined(childModel) || childModel["$$Parent"])
                    {
                        continue;
                    }
                    childModel["$$Parent"] = parent;
                }
            }

            const summaryColumns = this.$gridMetadataService.getSummaryColumns(
                this.viewMetadata.GridProperties.ClassMetadata
            );
            if (summaryColumns && summaryColumns.length !== 0)
            {
                this.$gridLoadService
                    .GetColumnSummaries(this.providerId, this.grid, this.viewMetadata, this.metadataServerPaging, summaryColumns, loadRecent)
                    .then(result =>
                    {
                        afterFetchResolve(result);
                    });
                return;
            }
        }

        afterFetchResolve();
        function afterFetchResolve(columnSummaries?: any): void
        {
            const columns = self.viewMetadata["$columns"];
            self.setCellClasses();
            if (self.$providerStorageService.ClearFilter[self.providerId])
            {
                self.clearFilter();
                self.$providerStorageService.ClearFilter[self.providerId] = false;
                // trigger reload of default layout after filter clear
                self.checkForLayout = true;
                self.layoutLoaded = false;
            }
            self.$providerStorageService.ApplyFilter[self.providerId] = false;

            if (!self.columns || self.columns.length === 0 || (columns && columns.length !== self.columns.length) || self.$providerStorageService.ReloadColumns[self.providerId])
            {
                self.columns = columns;
                self.$providerStorageService.ReloadColumns[self.providerId] = false;
            }
            else if (columns && columns.length !== 0)
                self.columns.forEach(column =>
                {
                    if (columns.find(x => x.Name === column.Name))
                    {
                        column.Label = columns.find(x => x.Name === column.Name).Label;
                        column.Visible = columns.find(x => x.Name === column.Name).Visible;
                        column.AlwaysHidden = columns.find(x => x.Name === column.Name).AlwaysHidden;
                    }
                });
            const data = self.$providerStorageService.GridData[self.providerId];
            self.setColumnSummaries(columnSummaries, data);
            self.remoteData.next(data);
            self.initialized = true;

            self.allowSort = !self.viewMetadata.GridProperties.DisableHeaderSorting;
            self.canAdd = self.viewMetadata.GridProperties.CanAdd;

            if (self.$cellEditService.CellEditCell[self.providerId] && data.length > 0 && data.filter(r => r.Id === self.$cellEditService.CellEditCell[self.providerId].id.rowID).length === 0)
                self.exitCellEdit();

            if (Utilities.IsNullOrUndefined(data))
            {
                self.fetching = false;
                self.grid.markForCheck();
                return;
            }

            self.totalCount = self.$gridLoadService.GetTotalRows(self.providerId);
            self.setSelectionMode();
            self.$gridSelectionService.SetSelectDisabled(self.providerId, self.viewMetadata);
            self.registerCommands();
            self.fetching = false;
            let forceDeselect = false;
            self.refreshAction = true;

            self.setPaginatorVisibility();

            if (self.checkForLayout && !self.layoutLoaded && self.totalCount > 0 && !self.$providerStorageService.SkipLayout[self.providerId])
            {
                self.initializeLayout()
                    .then((layout) =>
                    {
                        requestAnimationFrame(() =>
                        {
                            self.layoutLoaded = true;
                            if (layout)
                            {
                                self.$gridLayoutService.SetState(self.grid, self.state, layout, self.columns);
                            }
                            else
                            {
                                self.restoreLocalGridLayout();
                            }

                            self.pinDefaultColumns();
                            if (!self.shouldEditAfterAdd())
                                self.isAdding = false;
                        });
                    })
                    .finally(() => self.checkForLayout = false);
            }

            if (initial)
            {
                if (!self.shouldEditAfterAdd())
                    self.isAdding = false;
                self.$providerStorageService.SkipLayout[self.providerId] = undefined;
                self.$gridSelectionService.AllSelected = false;
                if (self.viewMetadata["$multipleDelete"] || (self.viewMetadata["$multipleEdit"] && !self.$multipleEntityEditService.ProviderId))
                {
                    delete self.viewMetadata["$multipleEdit"];
                    delete self.viewMetadata["$multipleDelete"];
                    self.grid.deselectAllRows(false);
                    self.$gridSelectionService.AllDeselected = true;
                    forceDeselect = true;
                }
                else self.$gridSelectionService.AllDeselected = false;
            }

            if (self.clearSkipLayout)
            {
                self.$providerStorageService.SkipLayout[self.providerId] = undefined;
                self.clearSkipLayout = false;
            }

            requestAnimationFrame(() =>
            {
                if (!self.$gridLoadService.Scrolling[self.providerId])
                    self.setGridHeight();
                self.setColumnWidths();
                self.setColumnFilterFormatting();
                self.MaybeRunRecalculate();

                for (const summaryField in columnSummaries)
                {
                    if (self.grid.columns.find(c => c.field === summaryField))

                        self.grid.columns.find(c => c.field === summaryField).pipeArgs = <IColumnPipeArgs>{digitsInfo: self.columns.find(x => x.Name === summaryField).DigitsInfo};
                }
                self.$gridLoadService.fireModelChangedListeners(self.providerId);
            });
            self.$gridSelectionService.SetSelected(
                self.providerId,
                self.grid,
                initial,
                self.viewMetadata,
                self.$gridSelectionService.AllSelected,
                self.$gridSelectionService.AllDeselected,
                forceDeselect,
                fromRecalculate
            );

            let gridScrollingTo: boolean = false;
            if (!self.cellEditing && !self.$gridSelectionService.Selecting && !self.holdScrollPosition)
            {
                let scrollPosition = parseInt(self.$gridLayoutService.ScrollPosition[self.providerId] ?? "0");
                if (self.infiniteScroll && scrollPosition > 0)
                {
                    self.grid.navigateTo(scrollPosition);
                    gridScrollingTo = true;
                }
                else
                    self.grid.navigateTo(0, initial ? 0 : -1, args =>
                    {
                        args.target.nativeElement.focus();
                        requestAnimationFrame(() => args.target.grid.verticalScroll.scrollPosition = scrollPosition);
                    });
            }
            self.holdScrollPosition = false;

            if (self.cellEditNextEditableEnabledChange)
            {
                self.cellEditNextEditableEnabledChange = false;
                self.$cellEditService.ActivateEditableCell(self.grid, self.$cellEditService.GetNextEditableCellSafe(self.grid, self.viewMetadata, self.currentColumnIndex, self.currentRowIndex, self.grid.columns[self.currentColumnIndex].visibleIndex));
            }

            self.grid.markForCheck();
            self.removeHiddenSorts();

            if (initial)
            {
                if (self.canAdd && !self.isViewOnly())
                {
                    self.$keyHandlerService.subscribe(self.constructor.name, Key.A, ModifierKey.Alt, "This Screen|Add item to grid", () =>
                    {
                        if (!self.isAdding)
                            self.addItem(true);
                    });
                }
            }

            requestAnimationFrame(() =>
            {
                self.showToolbar = true;
                self.$gridLoadService.Scrolling[self.providerId] = false;
            });

            if (!gridScrollingTo && initial && self.infiniteScroll && !self.grid.hasVerticalScroll() && self.$providerStorageService.GridData[self.providerId].length < self.totalCount)
                self.handlePreLoadImpl();

            self.cdr.detectChanges();

            if (self.afterFetchCallback)
            {
                const callback = self.afterFetchCallback;
                self.afterFetchCallback = null;
                callback();
            }

            if (self.shouldEditAfterAdd())
                self.cellEditAfterAdd();
        }
    }

    setColumnSummaries(columnSummaries: any, data: any): void
    {
        for (const summaryField in columnSummaries)
        {
            const summary = this.$gridFormatService.summaryFormatter(
                columnSummaries[summaryField],
                this.$gridMetadataService.getProperty(this.viewMetadata?.GridProperties.ClassMetadata, summaryField)?.Scale
            );

            data?.forEach(row =>
            {
                row[`total.${summaryField}`] = summary;
                row[`average.${summaryField}`] = summary.replace("$", "").replace(/,/g, "") / this.$providerStorageService.TotalHits[this.providerId];
            });
        }
    }

    pinDefaultColumns(): void
    {
        this.columns.filter(x => x.DefaultPinned).forEach(c =>
        {
            const column = this.grid.columns.find(x => x.field === c.Name);
            if (column)
                column.pinned = true;
        });
    }

    removeHiddenSorts(): void
    {
        if (!this.columns || !this.grid.sortingExpressions)
            return;

        for (let i = this.grid.sortingExpressions.length - 1, l = 0; i >= l; i--)
        {
            const expression = this.grid.sortingExpressions[i];
            const sortedColumn = this.columns.find(x => !x.AlwaysHidden && x.Name === expression.fieldName);
            if (!sortedColumn)
                this.grid.sortingExpressions.splice(this.grid.sortingExpressions.indexOf(expression), 1);
        }
    }

    get infiniteScroll(): boolean //TODO: if we can get all grids to do this, we can remove this setting and all its usages
    {
        return this.$providerStorageService.IsInfiniteScroll(this.providerId);
    }

    get isGroupedGrid(): boolean
    {
        return !!this.viewMetadata && this.viewMetadata.EditType === GridEditType.Groupable;
    }

    get enableLayout(): boolean
    {
        return this.$gridLayoutService.EnableLayout[this.providerId];
    }

    shouldLoadCachedLayout(): boolean
    {
        const cachedState: IGridState = <IGridState>JSON.parse(this.$gridLayoutService.LocalCachedLayout[this.providerId].split("|")[0]);
        let shouldLoad: boolean = true;
        this.viewMetadata["$columns"].forEach(c =>
        {
            if (shouldLoad)
            {
                const column = cachedState.columns.find(x => x.field === c.Name);
                if (column)
                {
                    //column became hidden outside of grid
                    if (!c.Visible && !column.hidden)
                        shouldLoad = false;
                    //column editability changed
                    // this check doesn't work as cachedState doesn't appear to be reliably synchronized with AllowCellEdit
                    // if (this.$cellEditService.AllowCellEdit(this.grid, this.viewMetadata, this.currentColumnIndex, c.Name) !== column.editable)
                    //     shouldLoad = false;
                }
            }

        });
        if (!shouldLoad && !this.$multipleEntityEditService.ProviderId)
            this.updateLayout(this.$gridLayoutService.LocalCachedLayout[this.providerId].split("|")[0]);
        return shouldLoad;
    }

    initializeLayout(): Promise<any>
    {
        const self = this;
        if (this.$gridLayoutService.HasLocalCachedLayout(this.providerId) && this.shouldLoadCachedLayout())
        {
            this.restoreLocalGridLayout();
            return Promise.resolve();
        }
        else
            if (this.viewMetadata.DisableLayout)
                return Promise.resolve(null);
        return this.$gridLayoutService.LayoutEnabled(this.providerId)
            .then((enabled: boolean) =>
            {
                if (enabled)
                    return self.$gridLayoutService.FetchDefaultLayout(self.providerId)
                        .then(layout =>
                        {
                            if (layout)
                            {
                                const parsed = layout.split("|");
                                layout = parsed[0];
                                if (parsed.length > 1)
                                {
                                    if (!self.infiniteScroll)
                                    {
                                        self.perPage = +parsed[1];
                                        self.page = +parsed[2];
                                    }
                                }
                            }
                            return layout;
                        });
            });
    }

    getColumnWidth(columnName: string): string
    {
        return this.initialWidths[columnName];
    }

    setColumnWidths(): void
    {
        this.grid.columns.forEach(c => this.setColumnWidth(c.field));
    }

    totalDefinedWidths: number = 0;

    setColumnWidth(columnName: string): void
    {
        const column = this.grid.columns.find(x => x.field === columnName);
        if (!column)
        {
            this.initialWidths[columnName] = null;
            return;
        }
        let width = this.$gridMetadataService.getProperty(
            this.viewMetadata?.GridProperties?.ClassMetadata,
            column.field
        )?.DrawWidth;
        if (width === -1)
            width = 100;
        if (this.layoutLoaded || !width)
        {
            this.initialWidths[columnName] = column.width;
            return;
        }
        if (width === 100 && this.grid.columns.length > 1)
            this.initialWidths[columnName] = null;
        else
        {
            this.totalDefinedWidths += width;
            if (this.totalDefinedWidths === 100)
            {
                this.initialWidths[columnName] = null;
                this.totalDefinedWidths = 0;
            }
            else
                this.initialWidths[columnName] = `${width}%`;
        }

    }

    get title(): string
    {
        return this.viewMetadata?.Title;
    }

    get singleCommand(): boolean
    {
        return this.hasCommands && this.viewMetadata.Actions.filter(x => !x.Hidden).length === 1;
    }

    get commandMenu(): boolean
    {
        return this.hasCommands && !this.singleCommand && this.hasSelection;
    }

    get commandBar(): boolean
    {
        return this.singleCommand && this.hasSelection;
    }

    get hasCommands(): boolean
    {
        return (
            this.initialized &&
            !Utilities.IsNullOrUndefined(this.viewMetadata.Actions) &&
            this.viewMetadata.Actions.length > 0
        );
    }

    get hasMultipleSelected(): boolean
    {
        if (this.gridUninitialized || !this.showDeleteMultiple)
        {
            return false;
        }
        return this.$gridSelectionService.SelectedCount[this.providerId] > 1;
    }

    get cellSelectionMode(): string
    {
        return "single";
    }

    get cellEditModelParent(): any
    {
        return this.cellEditModel.$$Parent;
    }

    deleteMultipleRows(): void
    {
        if (!this.allowDeleteMultiple())
        {
            this.$commonDialogsService.showAlertMessage("You are not allowed to delete the selected items.", "Delete items");
            return;
        }

        const selectedCount = this.$gridSelectionService.SelectedCount[this.providerId];
        const msg = `Are you sure you want to delete these ${selectedCount} items?`;

        this.$commonDialogsService.showConfirmationMessage(msg, `Delete ${selectedCount} items`)
            .then(() =>
            {
                if (this.useRepository)
                {
                    let models: any[];
                    if (this.$providerStorageService.LocalEntitiesStore[this.providerId])
                        models = this.$providerStorageService.LocalEntitiesStore[this.providerId];
                    else
                        models = this.$providerStorageService.GridData[this.providerId].map(x => x["$$model"]);
                    const deleteModels = models.filter(x => this.$gridSelectionService.SelectedIds[this.providerId].indexOf(this.$metadataTableService.GetId(this.viewMetadata.GridProperties.IdProperty, x, 0)) > -1);
                    this.viewMetadata["$multipleDelete"] = true;

                    deleteModels.forEach(model =>
                    {
                        const row = this.$providerStorageService.GridData[this.providerId].filter(x => Utilities.objectsEqual(x["$$model"], model))[0];
                        if (row)
                            row["$$Deleting"] = true;

                    });
                    this.$gridDeleteService.BulkDelete(deleteModels, this.datacontroller, this.model, this.viewMetadata)
                        .then(result =>
                        {
                            if (result.length> 0)
                            {
                                //these are retries, which all either have a valid exception, ASC or a VQH requiring a user response
                                this.isDeleteRetrying = true;
                                this.modelsToDelete = result;
                                this.indexToDelete = 0;
                                this.$gridDeleteService.triggerDeleteRetry();
                            }
                        });
                }
            });
    }

    processNextDelete(): void
    {
        if (!this.isDeleteRetrying)
            return;
        if (this.modelsToDelete.length <= this.indexToDelete)
        {
            this.$providerStorageService.SkipLayout[this.providerId] = true;
            this.$gridEventService.fireLoadMetadataTableListeners(<MetadataTableEventArg>{
                Type: this.viewMetadata.GridProperties.ClassMetadata.TypeName,
                AllSubPropertyGrids: false
            });

            this.viewMetadata["$$Deleting"] = false;
            this.$gridSelectionService.SetSelectedIds(this.providerId, []);
            this.isDeleteRetrying = false;
            this.modelsToDelete = [];
            this.indexToDelete = 0;
            return;
        }

        const model = this.modelsToDelete[this.indexToDelete];
        const row = this.$providerStorageService.GridData[this.providerId].filter(x => Utilities.objectsEqual(x["$$model"], model))[0];
        if (row)
            row["$$Deleting"] = true;

        this.repositoryFunction.emit(<RowCommandArgs>{
            command: "Delete",
            row: <RowCommandRow>{
                id: this.$metadataTableService.GetId(this.viewMetadata.GridProperties.IdProperty, model, 0),
                model: model
            }
        });
        this.indexToDelete++;
    }

    get showDeleteMultiple(): boolean
    {
        if (this.gridUninitialized)
            return false;
        if (this.viewMetadata?.SelectionMode !== SelectionMode.Multiple)
            return false;
        if (this.totalCount < 1)
            return false;
        if (!this.$gridSelectionService.SelectedIds[this.providerId] || this.$gridSelectionService.SelectedIds[this.providerId].length === 0)
            return false;
        if (!this.viewMetadata.GridProperties.CanDelete)
            return false;
        return true;
    }

    allowDeleteMultiple(): boolean
    {
        let canDelete = true;

        let models: any[];
        if (this.$providerStorageService.LocalEntitiesStore[this.providerId])
            models = this.$providerStorageService.LocalEntitiesStore[this.providerId];
        else
            models = this.$providerStorageService.GridData[this.providerId]?.map(x => x["$$model"]);
        if (!models || models.length === 0)
            return false;
        const selectedModels = models?.filter(x => this.$gridSelectionService.SelectedIds[this.providerId].indexOf(this.$metadataTableService.GetId(this.viewMetadata.GridProperties.IdProperty, x, 0)) > -1);
        if (selectedModels.length < this.$gridSelectionService.SelectedIds[this.providerId].length)
            return false;
        let i = 0;
        while (canDelete && i < selectedModels.length)
        {
            if (!this.$metadataTableService.CanDo("Delete", selectedModels[i], this.isViewOnly(), this.viewMetadata))
                canDelete = false;
            i++;
        }
        return canDelete;
    }

    get gridUninitialized(): boolean
    {
        return !this.initialized ||
            this.hideHeaderSelections ||
            Utilities.IsNullOrUndefined(this.grid);
    }

    get AllowMultipleDelete(): boolean
    {
        //Maybe support this at some point but currently, each row will be guaranteed to have to make separate recalc calls
        return !this.viewMetadata?.AllowDeleteCheckProperty && this.hasMultipleSelected;
    }

    get ColumnFiltering(): boolean
    {
        return !this.noFilter;
    }

    get AutoAddNewRow(): boolean
    {
        if (Utilities.IsNullOrUndefined(this.viewMetadata.GridProperties?.AutoAddNewRow))
            return true;
        return this.viewMetadata.GridProperties.AutoAddNewRow;
    }

    get hasFilter(): boolean
    {
        return Utilities.IsNullOrUndefined(this.grid?.filteredData) ? false : this.grid.filteredData.length > 0;
    }

    get showFiltered(): boolean
    {
        //Different from hasFilter() because we want to show this even if the count is zero
        return !Utilities.IsNullOrUndefined(this.grid?.filteredData);
    }

    shouldEditAfterAdd(): boolean
    {
        return this.cellAdding || this.$cellEditService.CellEditAfterAdd[this.providerId];
    }

    showIdTemplate(): boolean
    {
        return Utilities.IsNullOrUndefined(this.columns?.find(x => x.Name === "Id"));
    }

    columnHidden(name: string): boolean
    {
        return !this.columns.find(x => x.Name === name)?.Visible;
    }

    setupSummaryColumn(name: string): void
    {
        if (!this.$providerStorageService.GridData[this.providerId] || this.$providerStorageService.GridData[this.providerId].length === 0)
            return;
        const property = this.$gridMetadataService.getProperty(this.viewMetadata.GridProperties.ClassMetadata, name);
        if (Utilities.IsNullOrUndefined(property))
            return;
        this.summarySetup[name] =
        {
            HasSummary: property.SummaryType === MetadataSummary.Sum || property.SummaryType === MetadataSummary.Average,
            SummaryType: property.SummaryType
        };
    }

    useSummary(isCurrency: boolean, name: string): typeof CurrencySummary
    {
        if (!this.summarySetup[name])
            this.setupSummaryColumn(name);
        if (!this.summarySetup[name])
            return null;
        if (this.summarySetup[name].SummaryType === MetadataSummary.Average)
        {
            if (isCurrency)
                return this.currencyAverage;
            return this.average;
        }
        if (isCurrency)
            return this.currencySummary;
        return this.summary;
    }

    hasSummary(name: string): boolean
    {
        if (!this.summarySetup[name])
            this.setupSummaryColumn(name);
        if (!this.summarySetup[name])
            return false;
        return this.summarySetup[name].HasSummary;
    }

    registerCommands(): void
    {
        if (!this.hasCommands)
            return;
        this.commands = [];
        this.viewMetadata.Actions.forEach(cmd =>
        {
            const label = this.$metadataService.EvaluateString(
                cmd.Label, this.datacontroller?.Entity?.["$$Parent"], this.datacontroller?.Entity);

            this.commands.push(
                new LabelCommand({
                    label,
                    tooltip: label,
                    action: $event => this.performCommand(cmd, $event),
                    getEnabled: () => !this.$metadataService.GetPermissionDenied(cmd.Disabled, cmd.DisabledProperty, this.model, this.datacontroller),
                    getVisible: () => !this.$metadataService.GetPermissionDenied(cmd.Hidden, cmd.HiddenProperty, this.model, this.datacontroller)
                }));
        });
    }

    performCommand(action: IMetadataAction, $event?: Event): void
    {
        const self = this;
        if ($event !== undefined)
        {
            $event.stopPropagation();
        }

        const rows = this.$providerStorageService.GridData[this.providerId].filter(x => self.$gridSelectionService.SelectedIds[self.providerId].indexOf(x.Id) > -1);
        const metadataAction = Utilities.deepCopy(action);
        metadataAction.Context = null;

        let modelToUse: any;
        if (MetadataActionHelpers.isNoServicePath(action) && this.viewMetadata.SubPropertyName)
            modelToUse = this.model;
        else
            modelToUse = rows.map(x => x.Id);

        const repositoryForm = Utilities.IsNullOrUndefined(this.datacontroller)
            ? new RepositoryFormData(null, null)
            : this.datacontroller;
        this.$metadataActionService
            .ExecuteAction(
                modelToUse,
                metadataAction,
                repositoryForm
            )
            .then(_x =>
            {
                self.grid.selectionService.rowSelection.clear();
                self.$providerStorageService.GridData[self.providerId].forEach(x => (x.Selected = false));
                self.$gridSelectionService.SetSelectedIds(self.providerId, []);
            });
    }

    get hideRowSelectors(): boolean
    {
        return (
            this.viewMetadata?.SelectionMode !== SelectionMode.Multiple &&
            this.viewMetadata?.SelectionMode !== SelectionMode.Single
        );
    }

    setSelectionMode(): void
    {
        if (!this.initialized || Utilities.IsNullOrUndefined(this.grid))
            return;
        const enable = (this.hasCommands && this.viewMetadata.Actions.filter(x => !x.Hidden).length > 0) || this.viewMetadata["$selectOnly"];
        if (enable)
            this.selectionMode = this.getRowSelectionMode();
        else if (this.viewMetadata.EditAction || this.viewMetadata.EditForm)
            this.selectionMode = "multiple";
        else
            this.selectionMode = "none";
    }

    getRowSelectionMode(): string
    {
        if (!Utilities.IsNullOrUndefinedOrEmpty(this.viewMetadata.AllowSelectionProperty))
        {
            let model = this.model;
            if (this.viewMetadata.SubPropertyType && this.datacontroller.OtherEntities && this.datacontroller.OtherEntities[this.viewMetadata.SubPropertyType] && !this.viewMetadata.AllowSelectionProperty.includes("Parent"))
                model = this.datacontroller.OtherEntities[this.viewMetadata.SubPropertyType][0];

            if (this.$metadataService.EvaluateBoolean(this.viewMetadata.AllowSelectionProperty, model["$$Parent"], model))
                return this.viewMetadata?.SelectionMode === SelectionMode.Single ? "single" : "multiple";
            else
                return "none";
        }
        return this.viewMetadata?.SelectionMode === SelectionMode.Single ? "single" : "multiple";
    }

    addItem(leaveCellEdit: boolean): void
    {
        if (this.isGridCellEdit && this.hasFilter)
            this.addBooleanFilter("$cellEditAdded", true);

        this.isAdding = true;
        if (leaveCellEdit && this.cellEditing)
            this.leaveCellEdit(false);

        //TODO: should there be a max record count for doing this? Will any grid ever be a practical problem?
        if (this.isGridCellEdit && this.infiniteScroll)
            this.perPage = this.totalCount + 1;

        const self = this;
        requestAnimationFrame(() =>
        {
            self.fetching = true;
            self.cellEditing = false;
            if (self.useRepository)
                self.repositoryFunction.emit(<RowCommandArgs>{ command: "Add" });
            self.fetching = false;
        });
    }

    doAction(cell: IgxGridCell): boolean
    {
        const self = this;
        const row = cell.row.data;
        const column = self.columns.find(x => x.Name === cell.column.field);
        if (!column)
            return;
        if (this.isDisabled(cell) || this.isHidden(cell)) return;
        let actionToExecute: IMetadataAction;
        if (!Utilities.IsNullOrUndefined(column.MetadataAction)) actionToExecute = column.MetadataAction;
        else if (!Utilities.IsNullOrUndefined(column.LinkAction)) actionToExecute = column.LinkAction;
        else return false;
        this.$metadataTableService.FetchRowModel(row, this.datacontroller, this.viewMetadata)
            .then(model =>
            {
                row["$$model"] = model;
                self.$gridLoadService.fireModelChangedListeners(self.providerId);
                self.$gridActionService.PerformMetadataAction(
                    self.providerId,
                    row,
                    actionToExecute,
                    self.datacontroller,
                    self.viewMetadata,
                    self.repositoryFunction
                );
            });
    }

    getDataController(action: IMetadataAction, type: string): RepositoryFormData
    {
        if (Utilities.IsNullOrUndefined(action)) new RepositoryFormData(null, null);
        if (!Utilities.IsNullOrUndefined(this.datacontroller)) return this.datacontroller;
        if (!Utilities.IsNullOrUndefined(action.ViewToShow))
            type = this.$metadataViewService.GetTypeName(action.ViewToShow);
        return new RepositoryFormData(type, null);
    }

    isSelectionAllowed(id: string): boolean
    {
        return this.$gridSelectionService.IsSelectionAllowed(this.providerId, id);
    }

    rowCheckSelect(): void
    {
        this.$gridSelectionService.RowSelect = true;
    }

    /*
        TODO: MJ - igx v15 changed the output paramters for the row selection event. This works for now,
        but we may want to overhaul all the downstream code to account for the new way of selection
    */
    translateEvent(event: any): IRowSelectionEventArgs
    {
        let newEvent = {
            added: [],
            allRowsSelected: event.allRowsSelected,
            cancel: event.cancel,
            event: event.event,
            newSelection: [],
            oldSelection: [],
            owner: event.owner,
            removed: []
        };

        if (!Utilities.IsNullOrUndefinedOrEmpty(event.added))
            newEvent.added = event.added.map(x => x.Id);
        if (!Utilities.IsNullOrUndefinedOrEmpty(event.removed))
            newEvent.removed = event.removed.map(x => x.Id);
        if (!Utilities.IsNullOrUndefinedOrEmpty(event.oldSelection))
            newEvent.oldSelection = event.oldSelection.map(x => x.Id);
        if (!Utilities.IsNullOrUndefinedOrEmpty(event.newSelection))
            newEvent.newSelection = event.newSelection.map(x => x.Id);
        return newEvent;
    }

    public onCellSelect(event: IGridCellEventArgs): void
    {
        this.clearRowFocus();
        const row = this.grid.nativeElement.querySelector(`igx-grid-row[data-rowindex='${event.cell.row.index}'] igx-display-container`);
        if(row)
        {
            row.classList.add("row-focused");
        }
    }

    private clearRowFocus(): void
    {
        const elements = document.querySelectorAll('.row-focused');
        elements.forEach(element =>
        {
            element.classList.remove('row-focused');
        });
    }

    public onRowSelect(event: IRowSelectionEventArgs): void
    {
        const newEvent = this.translateEvent(event);
        if (!this.validSelection(newEvent))
        {
            event.cancel = true;
            return;
        }
        if (!this.$gridSelectionService.RowSelect && this.clickedInCell(newEvent))
        {
            let changedId: string;
            if (newEvent.added.length === 1)
                changedId = newEvent.added[0];
            else if (newEvent.removed.length === 1)
                changedId = newEvent.removed[0];
            if (changedId && !this.isSelectionAllowed(changedId))
            {
                event.cancel = true;
                return;
            }
            this.rowCheckSelect();
        }
        const self = this;
        let doOnSelected = (args: TableRowSelectArgs): void =>
        {
            self.doOnSelected(args);
        };
        this.$gridSelectionService.OnRowSelect(this.providerId, newEvent, this.viewMetadata, this.grid, doOnSelected);
        this.hasSelection = this.gridUninitialized ? false : this.$gridSelectionService.HasSelection(this.providerId);
    }

    validSelection(event: any): boolean
    {
        if (event.event.target.classList.contains("cell-edit"))
            event.cancel = true;
        if (event.event.target.parentElement.classList.contains("cell-edit"))
            event.cancel = true;
        if (event.event.target.parentElement.parentElement?.classList.contains("cell-action"))
            event.cancel = true;
        if (this.viewMetadata?.SelectionMode === SelectionMode.None)
            event.cancel = true;
        if (event.event.target.nodeName.toLowerCase() === "igx-grid-row" || event.event.target.nodeName.toLowerCase() === "igx-grid-cell" || (typeof event.event.target.className === "string" && event.event.target.className.toLowerCase() === "igx-grid-cell-value"))
            event.cancel = true;
        if (!Utilities.IsNullOrUndefined(event.event.target.closest("row-actions")))
            event.cancel = true;
        if (event.event.target.className === "grid-icon" || event.event.target.querySelector(".grid-icon"))
            event.cancel = true;
        if (event.event.target.parentElement.nodeName.toLowerCase() === "forge-checkbox"
                || event.event.target.nodeName.toLowerCase() === "forge-checkbox"
                || event.event.target.parentElement.nodeName.toLowerCase() === "metadata-input-checkbox"
                || event.event.target.nodeName.toLowerCase() === "metadata-input-checkbox")
            event.cancel = true;
        if (event.event.target.nodeName.toLowerCase() === "forge-icon")
            event.cancel = true;
        return !event.cancel;
    }

    clickedInCell(event: any): boolean
    {
        if (event.event.target.className === "row-selector" || event.event.target.querySelector(".row-selector"))
            return true;
        return false;
    }

    doOnSelected(args: TableRowSelectArgs): void
    {
        if (!Utilities.IsNullOrUndefined(this.onSelected))
            this.onSelected.emit(args);
    }

    private _cellStates = new Map<string, CellState>();

    private computeAllCellStates(): void
    {
        const fromScroll = this.$gridLoadService.Scrolling[this.providerId];
        if (!fromScroll)
            this._cellStates.clear();

        this.grid.allRows().filter(x => x !== undefined)
            .forEach((row, index) =>
            {
                this.columns.forEach(column =>
                {
                    const key = `${row.index}_${column.Name}`;
                    const cell = this.grid.getCellByColumn(index, column.Name) as IgxGridCell;
                    if (!this._cellStates.has(key))
                    {
                        this._cellStates.set(key, {
                            getIcon: this.setGetIcon(cell),
                            useIconSpan: this.setUseIconSpan(cell),
                            isDisabled: this.setIsDisabled(cell),
                            isHidden: this.setIsHidden(cell)
                        });
                    }
                });
            });
    }

    private getCellState(cell: IgxGridCell): CellState
    {
        const key = `${cell.id.rowIndex}_${cell.column.field}`;
        return this._cellStates.get(key);
    }

    cellActionClass(column: any, cell: IgxGridCell): boolean
    {

        if (column.IsLinkAction || column.IsMetadataAction)
        {
            const state = this.getCellState(cell);
            return !state?.isDisabled;
        }
        return false;
    }

    private setGetIcon(cell: IgxGridCell): string
    {
        const column = this.columns.find(x => x.Name === cell.column.field);
        if (!column?.Icon)
            return null;
        return this.$metadataService.EvaluateString(column.Icon, null, cell.row.data['$$model']);
    }

    getIcon(cell: IgxGridCell): string
    {
        const state = this.getCellState(cell);
        return state?.getIcon;
    }

    private setUseIconSpan(cell: IgxGridCell): boolean
    {
        const column = this.columns.find(x => x.Name === cell.column.field);
        return !!column && !!column.Icon ? column.Icon.startsWith("icon-") : false;
    }

    useIconSpan(cell: IgxGridCell): boolean
    {
        const state = this.getCellState(cell);
        return state?.useIconSpan;
    }

    private setIsHidden(cell: IgxGridCell): boolean
    {
        return this.isRestricted(cell, "Hidden");
    }

    isHidden(cell: IgxGridCell): boolean
    {
        const state = this.getCellState(cell);
        return state?.isHidden;
    }

    private setIsDisabled(cell: IgxGridCell): boolean
    {
        return this.isRestricted(cell, "Disabled");
    }

    isDisabled(cell: IgxGridCell): boolean
    {
        const state = this.getCellState(cell);
        return state?.isDisabled || this.isDisabledAction(cell);
    }

    isDisabledAction(cell: IgxGridCell): boolean
    {
        if (!this.recalculating())
            return false;
        const column = this.columns.find(x => x.Name === cell.column.field);
        if (!column)
            return false;
        return !Utilities.IsNullOrUndefinedOrEmpty(column.MetadataAction);
    }

    private isRestricted(cell: IgxGridCell, level: string): boolean
    {
        if (Utilities.IsNullOrUndefined(this.$providerStorageService.GridData[this.providerId])) return false;
        const row = cell.row.data;
        if (!row)
            return false;
        const column = this.columns.find(x => x.Name === cell.column.field);
        if (!column)
            return false;
        let actionToEvaluate: IMetadataAction;
        if (!Utilities.IsNullOrUndefined(column.MetadataAction))
            actionToEvaluate = column.MetadataAction;
        else if (!Utilities.IsNullOrUndefined(column.LinkAction))
            actionToEvaluate = column.LinkAction;
        else
            return false;
        let toCheck = actionToEvaluate.Hidden;
        let toCheckProperty = actionToEvaluate.HiddenProperty;
        if (level === "Disabled")
        {
            toCheck = actionToEvaluate.Disabled;
            toCheckProperty = actionToEvaluate.DisabledProperty;
        }
        return this.$metadataService.GetPermissionDenied(toCheck, toCheckProperty, row["$$model"]);
    }

    get allowCsvExport(): boolean
    {
        return Utilities.IsNullOrUndefinedOrEmpty(this.grid.groupingExpressions);
    }

    exportData(type: string): void
    {
        this.toolbar.showProgress = true;

        let exportService;
        if (type === "excel")
            exportService = this.excelExportService;
        else
            exportService = this.csvExportService;

        const cellFormatColumns = this.viewMetadata["$columns"].filter(x => x.DataType === "percent" || x.DataType === "boolean");

        const destroyExportPipe$ = new Subject<void>();
        exportService.columnExporting.pipe(takeUntil(destroyExportPipe$)).subscribe((columnsArgs: IColumnExportingEventArgs) =>
        {
            const column =  this.viewMetadata["$columns"].find(x => x.Name === columnsArgs.field);
            //numbers will export as numbers with no scale formatting
            if (column?.DataType === "number" || column?.DataType === "nonDelineatedNumber")
                columnsArgs.skipFormatter = true;
            //TODO: numbers will export with scale formatting if it is there, but formatted as string. igx has no solution to accommodate both
            // if (!column?.DigitsInfo)
            //     columnsArgs.skipFormatter = true;

            const header = column?.Label.replace(/&/g, "&amp;");
            if (header)
                columnsArgs.header = header;
        });
        exportService.rowExporting.pipe(takeUntil(destroyExportPipe$)).subscribe((args: IRowExportingEventArgs) =>
        {
            cellFormatColumns.forEach(column =>
            {
                let value = args.rowData[column.Name];
                if (column.DataType === "percent")
                {
                    if (!isNaN(+value))
                        args.rowData[column.Name] = +value / 100;
                }
                else if (column.DataType === "boolean")
                {
                    if (Utilities.IsNullOrUndefined(value))
                        args.rowData[column.Name] = "";
                    else
                        args.rowData[column.Name] = value.toString().toUpperCase();
                }

            });
        });

        const self = this;

        const reload = (this.model && this.model.$applyProperty && this.model.MaxResultMessage) ?
                        self.$commonDialogsService.showConfirmationMessage("The number of records in the grid has been limited. " +
                            "Loading all available data may result in extended processing time. Would you like to load all available data?", "Alert", "Yes", "No")
                        .then(() => true, () => false) : Promise.resolve(false);

        reload.then(x => {
            if (x)
            {
               this.afterFetchCallback = () => doExport();

                this.model.OverrideResultLimit = true;
                this.model.$forExport = true;
                this.$metadataPropertyService.recalculateProperties(
                    this.model.$$TypeName,
                    this.model.$applyProperty,
                    this.model,
                    this.model.$$parent,
                    this.model[this.model.$applyProperty.Name],
                    undefined,
                    true,
                    true,
                    this.datacontroller
                );
            }
            else {
                this.$gridLoadService.getData(this.grid, this.model, this.viewMetadata, this.metadataServerPaging,
                    false, () => doExport(), null, null, null, null);
            }
        });


        function doExport(): void
        {
            let title: string;
            if (!Utilities.IsNullOrUndefinedOrEmpty(self.viewMetadata.Title))
                title = self.viewMetadata.Title;
            else if (!Utilities.IsNullOrUndefinedOrEmpty(self.viewMetadata?.Title))
                title = self.viewMetadata.Title;
            else
                title = self.$omniBarService.title;
            title = Utilities.IsNullOrUndefinedOrEmpty(title) ? "ExportedData" : `${title} Export`;

            let args: IGridToolbarExportEventArgs = <IGridToolbarExportEventArgs>{};
            if (type === "excel")
                args.options = new IgxExcelExporterOptions(title);
            else
            {
                args.options = new IgxCsvExporterOptions(title, CsvFileTypes.CSV);
                args.options.exportSummaries = false;
            }

            const data = self.$providerStorageService.GridData[self.providerId];
            self.setColumnSummaries(self.$providerStorageService.ColumnSummaries[self.providerId], data);
            self.remoteData.next(data);
            self.cdr.detectChanges();
            exportService.export(self.grid, args.options);

            self.toolbar.showProgress = false;
            destroyExportPipe$.next();
            destroyExportPipe$.complete();
        }
    }

    get isGridCellEdit(): boolean
    {
        return !!this.viewMetadata && this.viewMetadata.EditType === GridEditType.Cell;
    }

    get skipSort(): boolean
    {
        return (this.isAdding && this.isGridCellEdit) || this.cellEditing;
    }

    cellEditAfterAdd(): void
    {
        this.cellAdding = false;
        this.$cellEditService.CellEditAfterAdd[this.providerId] = false;
        const rowIndex =
            this.viewMetadata.GridProperties.AddToTop || this.grid.data.length === 0
                ? 0
                : this.grid.data.length - 1;

        const position = this.$cellEditService.GetFirstEditableCell(this.grid, this.viewMetadata, rowIndex, 0);
        if (!position)
        {
            this.isAdding = false;
            return;
        }
        this.setModelForCellEdit(this.$providerStorageService.GridData[this.providerId][rowIndex].Id, this.grid.columns[position.visibleColumnIndex].field);
        this.setMetadataForCellEdit(this.grid.columns[position.visibleColumnIndex].field);
        if (!this.viewMetadata.GridProperties.AddToTop && !this.editFirstCellAfterAdd)
        {
            const lastPage = this.getLastPage();
            if (this.infiniteScroll)
            {
                if (this.grid.data.length < this.totalCount)
                {
                    this.page = 0;
                    this.perPage = this.totalCount;
                    this.editFirstCellAfterAdd = true;
                    this.fetch();
                    return;
                }
            }
            else if (this.page !== lastPage)
            {
                this.page = lastPage;
                this.editFirstCellAfterAdd = true;
                this.fetch();
                return;
            }
        }
        this.editFirstCellAfterAdd = false;
        if (!Utilities.IsNullOrUndefined(position))
        this.$cellEditService.ActivateEditableCell(this.grid, position, true);
        this.isAdding = false;
        this.fetching = false;
    }

    cellEditKeyDown(event: KeyboardEvent): void
    {
        if (event.code !== "ArrowUp" && event.code !== "ArrowDown")
            return;

        this.disableGridScroll(false);

        const propertyMetadata = this.cellEditMetadata.Properties.find(p => p.Name === this.grid.columns[this.currentColumnIndex].field);
        const inputType = propertyMetadata?.InputType;

        if (!this.$cellEditService.VerticalEditNavigationAllowed(event.code, this.$providerStorageService.GridData[this.providerId], this.currentRowIndex, inputType))
            return;
        this.$cellEditService.EditNextVerticalCell(this.grid, this.viewMetadata, this.currentRowIndex, this.currentColumnIndex, event.code === "ArrowUp");

        this.disableGridScroll(true);
    }

    currentColumnIndex: number;
    currentRowIndex: number;
    cellEditTransition: boolean = false;

    editCheckbox(cell: IgxGridCell): void
    {
        const self = this;
        const field = cell.column.field;
        const columnId = cell.id.columnID;
        this.currentColumnIndex = columnId;
        if (!this.isGridCellEdit || !this.$cellEditService.AllowCellEdit(this.grid, this.viewMetadata, this.currentColumnIndex, field, this.grid.getCellByColumn(cell.id.rowIndex, field)))
            return;
        requestAnimationFrame(() =>
        {
            if (!this.cellEditing)
            {
                self.setModelForCellEdit(cell.id.rowID, field);
                self.setMetadataForCellEdit(field);
                const row = self.$providerStorageService.GridData[self.providerId].find(x => x.Id === cell.id.rowID);
                const newValue = !this.cellEditModel[field];
                this.cellEditModel[field] = newValue;
                row[field] = newValue;
                cell.editValue = newValue;
                self.$cellEditService.RecalculateAfterCellEdit(self.cellEditModel, self.cellEditMetadata, field, self.currentEditCellOriginalModelValue, true, self.datacontroller);
                self.$gridLoadService.fireModelChangedListeners(self.providerId);
                self.setCellClasses();
                self.grid.cdr.detectChanges();
                self.exitCellEdit();
                self.holdScrollPosition = true;
            }
        });
    }

    parseBooleanValue(value: any): boolean
    {
        if (typeof value === "string")
            return value === "true" || value === "True" || value === "1";
        return value;
    }

    handleGridKeydown(evt: IGridKeydownEventArgs): void
    {
        const key = evt.event["key"].toLowerCase();
        const shift = evt.event["shiftKey"];

        if (key !== "tab" || !evt.target.editMode)
            return;

        evt.cancel = true;

        const propertyMetadata = this.cellEditMetadata.Properties.find(p => p.Name === this.grid.columns[this.currentColumnIndex].field);
        if (propertyMetadata?.InputType === "Check")
            this.$cellEditService.ViewOnly = {};

        const activeCell = {
            row: evt.target.row.index as number,
            column: evt.target.visibleColumnIndex as number
        };

        const rowIndex = activeCell.row;
        const isAtFirstColumn = activeCell.column === 0;
        const isFirstRow = activeCell.row === 0;

        let rowIndexForPermission = rowIndex;
        let followingPosition = null;

        if (shift)
        {
            if (isAtFirstColumn && !isFirstRow)
                rowIndexForPermission = rowIndex - 1;
            followingPosition = this.$cellEditService.GetPreviousEditableCell(this.grid, this.viewMetadata, this.currentColumnIndex, rowIndex, activeCell.column, rowIndexForPermission);
        }
        else
            followingPosition = this.$cellEditService.GetNextEditableCellSafe(this.grid, this.viewMetadata, this.currentColumnIndex, activeCell.row, activeCell.column);
        if (followingPosition === null)
        {
            let event = <IGridEditEventArgs>{
                event: evt.event,
                column: {field: this.grid.columns[this.currentColumnIndex].field},
                cellID: {rowIndex: rowIndex},
                rowData: this.grid.data[rowIndex]
            };
            this.leaveCellEdit(false, event);
        }
        else
            this.$cellEditService.ActivateEditableCell(this.grid, followingPosition);
    }

    onCellEditEnter(event: IGridEditEventArgs)
    {
        if (!this.$metadataViewService.IsCellEditGrid(this.viewMetadata))
        {
            event.cancel = true;
            return;
        }

        this.currentColumnIndex = event.cellID.columnID;
        if (!this.$cellEditService.AllowCellEdit(this.grid, this.viewMetadata, this.currentColumnIndex, event.column.field, this.grid.getCellByColumn(event.cellID.rowIndex, event.column.field), false))
        {
            event.cancel = true;
            const position = this.$cellEditService.GetNextEditableCellSafe(this.grid, this.viewMetadata, this.currentColumnIndex, event.cellID.rowIndex, this.grid.columns[this.currentColumnIndex].visibleIndex);
            if (position)
                requestAnimationFrame(() => this.$cellEditService.ActivateEditableCell(this.grid, position, true));
        }
        else
            this.beginCellEdit(event);
    }

    onScroll(event: IGridScrollEventArgs): void
    {
        if(this.cellEditing)
        {
            (event.event.target as HTMLElement).scrollTop = this._gridScrollTop;
        }
    }

    private _gridScrollTop = 0;

    disableGridScroll(disable: boolean): void
    {
        const scrollBar = this.grid.nativeElement.querySelector(".igx-vhelper--vertical") as HTMLElement;
        this._gridScrollTop = scrollBar.scrollTop;
        scrollBar.style.overflow = disable ? "hidden" : "auto";
    }

    beginCellEdit(event: IGridEditEventArgs): void
    {
        const self = this;
        this.grid.sortingExpressions = [];
        this.$gridLoadService.SortingExpressions[this.providerId] = [];

        this.disableGridScroll(true);

        if (this.delayUpdate)
        {
            this.cellEditTransition = true;
            setTimeout(() => self.beginCellEditImpl(event), 15);
        }
        else
            self.beginCellEditImpl(event);
        this.delayUpdate = false;
    }

    beginCellEditImpl(event: IGridEditEventArgs): void
    {
        const self = this;
        const rowId = event.rowID;
        const rowIndex = event.cellID.rowIndex;
        const columnField = event.column.field;
        const columnId = event.cellID.columnID;
        const cell = this.grid.getCellByColumn(rowIndex, columnField);
        this.$cellEditService.CellEditCell[this.providerId] = cell;
        this.setModelForCellEdit(rowId, columnField);
        this.setMetadataForCellEdit(columnField);
        this.currentColumnIndex = columnId;
        if (this.currentRowIndex !== rowIndex)
            this.$cellEditService.ClearCellEditErrors(this.cellEditModel);
        this.currentRowIndex = rowIndex;
        this.cellEditTransition = false;
        this.cellEditing = true;
        this.$cellEditService.ViewOnly = {};
        const propertyMetadata = this.cellEditMetadata.Properties.find(p => p.Name === columnField);
        const inputType = propertyMetadata?.InputType;
        if (self.$metadataInputTypeHelperService.isCheck(inputType) && event.event instanceof PointerEvent)
        {
            if (this.recalculating())
                this.runCheckboxEdit.set(()=> this.checkboxEdit(cell, columnField));
            else
                this.checkboxEdit(cell, columnField);
            return;
        }
        this.handleCommandService();
    }

    checkboxEdit(cell: CellType, columnField: string): void
    {
        const row = this.$providerStorageService.GridData[this.providerId].find(x => x.Id === cell.id.rowID);
        const newValue = !this.cellEditModel[columnField];
        this.cellEditModel[columnField] = newValue;
        row[columnField] = newValue;
        this.$cellEditService.RecalculateAfterCellEdit(this.cellEditModel, this.cellEditMetadata, columnField, this.currentEditCellOriginalModelValue, true, this.datacontroller);
        this.handleCommandService();
    }

    handleCommandService(): void
    {
        // const self = this;
        setTimeout(() =>
        {
            if (this.$cellEditCommandService.isOpen)
                this.$cellEditCommandService.Close();
            if (this.cellEditInput)
                this.$cellEditCommandService.Open(this.cellEditInput.nativeElement, CellEditOverlay, this.viewContainerRef, (c: boolean) => this.leaveCellEdit(c));
        }, 50);
    }

    setModelForCellEdit(id: string, property: string): void
    {
        const row = this.$providerStorageService.GridData[this.providerId].find(x => x.Id === id);
        const model = row["$$model"];
        this.cellEditModel = this.$gridMetadataService.getModelForProperty(
            this.viewMetadata.GridProperties.ClassMetadata,
            property,
            model
        );
        if (Utilities.IsNullOrUndefined(this.cellEditModel))
            this.cellEditModel = <AugmentedModelObject>{};
        this.currentEditCellOriginalModelValue = model[property];
        this.currentEditCellOriginalDisplayValue = row[property];
        this.currentEditCellPropertyName = property;
        this.datacontroller.SetInitialModCountEntity(this.cellEditModel, false);
    }

    setMetadataForCellEdit(property: string): void
    {
        this.cellEditMetadata = this.$gridMetadataService.getClassMetadataForProperty(
            this.viewMetadata.GridProperties.ClassMetadata,
            property
        );
    }

    leaveCellEdit(cancel: boolean, event: IGridEditEventArgs = null): void
    {
        const self = this;
        if (cancel) this.$cellEditService.CellEditCancel[this.providerId] = true;
        requestAnimationFrame(() => self.endCellEditImpl(self.$cellEditService.CellEditCell[self.providerId].column.field, self.$cellEditService.CellEditCell[self.providerId].row.key, event));
        this.grid.crudService.endEditMode();
        this.grid.notifyChanges();
    }

    endCellEdit(event: IGridEditEventArgs): void
    {
        const self = this;
        const inputType = this.cellEditMetadata.Properties.find(p => p.Name === event.column.field)?.InputType;
        if (inputType === "Button" && event)
        {
            this.handleLastCellEdit(event);
            return;
        }

        let rowId = event.rowKey;
        if (Utilities.IsNullOrUndefined(rowId))
        {
            rowId = this.grid.getRowByIndex(event.cellID.rowIndex).key;
        }

        const selectType = this.$metadataInputTypeHelperService.isSelect(inputType) || this.$metadataInputTypeHelperService.isTypeAhead(inputType);

        if (
            (selectType ||
                this.$metadataInputTypeHelperService.isDate(inputType) ||
                this.$metadataInputTypeHelperService.isTime(inputType) ||
                this.$metadataInputTypeHelperService.isTime24(inputType))
        )
        {
            this.delayUpdate = !this.$cellEditService.CellEditCancel[this.providerId];
            //TODO: if this is higher it "works" but screws the timing of currentEditCellOriginalModelValue setting for recalc, maybe fix as separate issue since it is already happening
            setTimeout(() => self.endCellEditImpl(event.column.field, rowId, event), 10);
        }
        else self.endCellEditImpl(event.column.field, rowId, event);
    }

    endCellEditImpl(field: string, rowId: string, event: IGridEditEventArgs = null): void
    {
        try
        {
            this.disableGridScroll(false);

            const row = this.$providerStorageService.GridData[this.providerId].find(x => x.Id === rowId);
            if (this.$cellEditService.CellEditCancel[this.providerId])
            {
                if (row["$$model"]["$pristine"])
                {
                    this.datacontroller.Remove(
                        this.viewMetadata.GridProperties.ClassMetadata.TypeName,
                        row["$$model"],
                        this.$metadataViewService.createFilterString(row["$$model"], this.viewMetadata)
                    );
                    this.$gridEventService.fireTableEntitiesChangedListeners(this.providerId);
                }
                else if (!this.recalculatedDuringEdit)
                {
                    row["$$model"][field] = this.currentEditCellOriginalModelValue;
                    row[field] = this.currentEditCellOriginalDisplayValue;
                }
                return;
            }
            row["$$model"]["$pristine"] = false;
            this.$cellEditService.SetCellEditErrors(row["$$model"]);
            if (this.cellEditModel[field] !== this.currentEditCellOriginalModelValue)
                this.$cellEditService.RecalculateAfterCellEdit(this.cellEditModel, this.cellEditMetadata, field, this.currentEditCellOriginalModelValue, false, this.datacontroller);

            let newValue = this.cellEditModel[field];
            const propertyMetadata = this.cellEditMetadata.Properties.find(p => p.Name === field);

            this.$cellEditService.AfterCellEdit(
                this.$cellEditService.CellEditCell[this.providerId],
                row,
                propertyMetadata,
                this.viewMetadata,
                this.grid,
                this.providerId,
                newValue
            );
            this.updateSummaries(field, this.currentEditCellOriginalModelValue, newValue);
            if (event) this.handleLastCellEdit(event);
        }
        finally
        {
            this.endCellEditFinal();
        }
    }

    endCellEditFinal(): void
    {
        this.setCellClasses();
        this.exitCellEdit();
        this.$cellEditCommandService.Close();
    }

    exitCellEdit(): void
    {
        this.$cellEditService.ViewOnly = {};
        if (!this.cellEditAddWaitForRecalculate)
            this.$cellEditService.CellEditCell[this.providerId] = undefined;
        this.$cellEditService.CellEditCancel[this.providerId] = false;
        this.currentEditCellOriginalModelValue = undefined;
        this.currentEditCellOriginalDisplayValue = undefined;
        this.currentEditCellPropertyName = undefined;
        this.cellEditing = false;
        this.recalculatedDuringEdit = false;
    }

    handleLastCellEdit(event: IGridEditEventArgs, enterEditMode: boolean = false): void
    {
        if (Utilities.IsNullOrUndefined(event.event) || event.event.type !== "keydown") return;
        const key = event.event as KeyboardEvent;
        if (key.key === "Tab" && !key.shiftKey && this.$cellEditService.IsLastEditableColumn(this.grid, this.viewMetadata, event.cellID.rowIndex, this.grid.columns[this.currentColumnIndex].visibleIndex) && event.cellID.rowIndex === this.grid.totalRowsCountAfterFilter - 1)
        {
            if (!this.infiniteScroll && this.page !== this.getLastPage())
            {
                this.page += 1;
                this.fetch();
                setTimeout(() =>
                {
                    this.$cellEditService.EditFirstCell(this.grid, this.viewMetadata, 0, enterEditMode);
                }, 1);
            }
            else if (this.AutoAddNewRow && this.canAdd)
            {
                if (this.cellEditMetadata.Properties.find(p => p.Name === event.column.field).RecalculateOnChange && this.currentEditCellOriginalModelValue !== event.rowData[event.column.field])
                    this.cellEditAddWaitForRecalculate = true;
                else
                    this.addItem(false);
            }
        }
    }

    updateSummaries(field: string, originalValue: number, newValue: number): void
    {
        const self = this;
        if (this.$providerStorageService.GridData[this.providerId]?.length > 0)
        {
            const summaryColumns = this.$gridMetadataService.getSummaryColumns(
                this.viewMetadata.GridProperties.ClassMetadata
            );
            if (summaryColumns?.length !== 0)
            {
                const col = summaryColumns.find(c => c === field);
                if (col)
                {
                    self.$providerStorageService.ColumnSummaries[self.providerId][field] -= originalValue;
                    self.$providerStorageService.ColumnSummaries[self.providerId][field] += newValue;
                }

                this.$gridLoadService
                    .GetColumnSummaries(this.providerId, this.grid, this.viewMetadata, this.metadataServerPaging, summaryColumns, false)
                    .then(result =>
                    {
                        self.setColumnSummaries(result, self.grid.data);
                        self.grid.summaryService.clearSummaryCache();
                        self.grid.summaryService.calculateSummaries(
                            self.grid.summaryService.rootSummaryID,
                            self.grid.data,
                            undefined
                        );
                    });
            }
        }
    }

    noFormatAction(column: any): boolean
    {
        return (
            column.DataType !== "percent" &&
            column.DataType !== "number" &&
            column.DataType !== "date" &&
            column.DataType !== "time" &&
            column.DataType !== "dateTime" &&
            !column.IsCurrency
        );
    }

    setColumnFilterFormatting(): void
    {
        if (!this.columns)
            return;
        this.columns.forEach(c =>
        {
            const column = this.grid.getColumnByName(c.Name);
            if (column)
            {
                if (c.DataType === "date")
                {
                    column.formatter = (value: any) =>
                    {
                        if (!!value)
                            return formatDate(value, "MM/dd/yyyy", this.locale);
                        return "";
                    };
                }
                if (c.DataType === "dateTime")
                {
                    const format = this.timeFormat(c.Name, true);
                    column.defaultDateTimeFormat = format;
                    column.formatter = (value: any) =>
                    {
                        if (!!value)
                            return formatDate(value, format, this.locale);
                        return "";
                    };
                }
                else if (c.DataType === "percent")
                {
                    column.formatter = (value: any) => this.$gridFormatService.numberFormatter(value, c, true);
                }
                else if (c.DataType === "number")
                {
                    if (c.IsCurrency)
                        column.formatter = (value: any) => this.$gridFormatService.currencyFormatter(value, c);
                    else
                        column.formatter = (value: any) => this.$gridFormatService.numberFormatter(value, c, false);
                }
                else if (c.DataType === "nonDelineatedNumber")
                {
                    column.formatter = (value: any) => this.$gridFormatService.nonDelineatedNumberFormatter(value, c);
                }
            }
        });
    }

    MaybeRunRecalculate(): void
    {
        if (!this.runRecalculate)
            return;
        this.runRecalculate = false;
        if (!this.viewMetadata.SubPropertyRecalculateOnFilter)
            return;

        let type = this.model.$$TypeName;
        if (!type && this.datacontroller)
            type = this.datacontroller.Type;
        const propertyMetadata = <PropertyMetadata>{
            Name: this.viewMetadata.SubPropertyName,
            RecalculateOnChange: this.$metadataPropertyService.getPropertiesToRecalculate(this.viewMetadata.SubPropertyRecalculateOnFilter),
            RecalculateToIgnore: this.viewMetadata.SubPropertyRecalculateOnFilter.PropertiesToIgnore
        };

        //dont love this, but this may never be used anywhere but one place, so dont want to rewrite a whole new pattern yet
        this.model[this.viewMetadata.SubPropertyName].map(x => x["inFilter"] = x.$inFilter ? true : false);

        this.$metadataPropertyService.recalculateProperties(
            type,
            propertyMetadata,
            this.model,
            this.model.$$parent,
            this.model[this.viewMetadata.SubPropertyName].filter(x => x.$inFilter),
            undefined,
            true,
            true,
            this.datacontroller);
    }

    get filterHeight(): string
    {
        return this.showCustomFilter ? "234px" : this.showExcelStyleSearch ? "380px" : "218px";
    }

    get showExcelStyleSearch(): boolean
    {
        return !this.metadataServerPaging;
    }

    get showCustomFilter(): boolean
    {
        return this.metadataServerPaging;
    }

    clearCustomFilter(): void
    {
        if (this.showCustomFilter)
            this.$gridFilterService.clearCustomFilter();
    }

    private _cellEditing: boolean = false;
    private _cellAdding: boolean = false;

    get cellEditing(): boolean
    {
        return this._cellEditing;
    }

    set cellEditing(value: boolean)
    {
        if (!Utilities.IsNullOrUndefined(this.viewMetadata)) this.viewMetadata["$$cellEditing"] = value;
        this._cellEditing = value;
    }

    get cellAdding(): boolean
    {
        return this._cellAdding;
    }

    set cellAdding(value: boolean)
    {
        if (!Utilities.IsNullOrUndefined(this.viewMetadata)) this.viewMetadata["$$cellAdding"] = value;
        this._cellAdding = value;
    }

    get layoutOptions(): IMenuOption[]
    {
        return [{
            value: "load",
            label: "Load",
        },
        {
            value: "save",
            label: "Save",
        },
        {
            value: "delete",
            label: "Delete",
        },
        {
            value: "restore",
            label: "Restore",
        }];
    }

    get showTitle(): boolean
    {
        return (
            this.initialized &&
            !Utilities.IsNullOrUndefinedOrEmpty(this.viewMetadata.Title) &&
            this.displayHeader
        );
    }

    get showH1Title(): boolean
    {
        if(this.combinedViewTable)
        {
            const showForCombined = this.viewMetadata["$$ParentView"].Views.length === 1;
            return !this.showTitle && showForCombined && this.displayHeader;
        }

        return !this.showTitle && this.displayHeader;
    }

    get h1Title(): string
    {
        return this.$omniBarService.title;
    }

    readonly isViewOnly: Signal<boolean> = computed(() =>
    {
        return this.viewMetadata.ViewOnly || this.recalculating();
    });

    getLastPage(): number
    {
        let pages = 0;
        pages = Math.ceil(this.totalCount / this.perPage);
        return pages ? pages - 1 : 0;
    }

    layoutAction(_e: unknown): void
    {
        const action = this.gridLayoutDropdown.selectedItem ? this.gridLayoutDropdown.selectedItem.value : "";
        switch (action)
        {
            case "load":
                this.loadGridState(false);
                break;
            case "save":
                this.saveGridState(false);
                break;
            case "delete":
                this.deleteGridState();
                break;
            case "restore":
                this.restoreGridState();
                break;
        }
        this.gridLayoutDropdown.clearSelection();
    }

    saveGridState(local: boolean): void
    {
        this.$gridLayoutService.SaveLayout(this.providerId, this.state, this.perPage, this.page, local);
    }

    loadGridState(local: boolean): void
    {
        const self = this;
        const providerId = this.providerId ? this.providerId : self.viewMetadata?.GridProperties["$providerId"];
        if (providerId)
            this.$gridLayoutService.LoadLayout(providerId, local)
                .then(layout =>
                {
                    if (layout)
                    {
                        self.layoutLoading = true;
                        const parsed = layout.split("|");
                        layout = parsed[0];
                        if (parsed.length > 1 && !self.infiniteScroll)
                        {
                            self.perPage = +parsed[1];
                            self.page = +parsed[2];
                            if (self.page > self.$providerStorageService.TotalHits[self.providerId] / self.perPage)
                                self.page = 0;
                        }
                        if (local && !self.firstLayoutLoadFromCache)
                            self.updateLayout(layout);
                        else
                            self.$gridLayoutService.SetState(self.grid, self.state, layout, self.columns);

                        self.firstLayoutLoadFromCache = false;
                    }
                });
    }

    firstLayoutLoadFromCache: boolean = true;

    updateLayout(layout: string): void
    {
        //if column visibility changed, update layout
        const cachedState = Utilities.parseJson(layout);
        let hasChanged = false;
        if (!cachedState || !cachedState["columns"])
            return;
        cachedState.columns.forEach(column =>
        {
            const match = this.columns.find(x => x.Name === column.field);
            if (match)
                if (column.hidden === match.Visible)
                {
                    column.hidden = !match.Visible;
                    hasChanged = true;
                }

        });
        if (hasChanged)
        {
            let newLayout = Utilities.stringify(cachedState);
            this.$gridLayoutService.SetState(this.grid, this.state, newLayout, this.columns);
            newLayout = `${newLayout}|${this.perPage}|${this.page}`;
            this.$gridLayoutService.LocalCachedLayout[this.providerId] = newLayout;
            let self = this;
            requestAnimationFrame(() => self.grid.markForCheck());
        }
    }

    deleteGridState(): void
    {
        this.$gridLayoutService.DeleteLayout(this.providerId);
    }

    restoreGridState(): void
    {
        this.restoringLayout = true;
        this.grid.sortingExpressions = [];
        this.$gridLoadService.SortingExpressions[this.providerId] = [];
        this.grid.groupingExpressions = [];
        for (let i = this.grid.pinnedColumnsCount - 1, l = 0; i >= l; i--)
        {
            this.grid.pinnedColumns[i].unpin();
        }
        this.grid.columns.forEach(x => x.hidden = false);
        requestAnimationFrame(() => this.grid.columns.forEach(x => this.setColumnWidth(x.field)));

        let prevColumn: IgxColumnComponent;
        this.columns.forEach(x =>
        {
            const gridColumn = this.grid.columns.find(c => c.field === x.Name);
            if (prevColumn)
                this.grid.moveColumn(gridColumn, prevColumn, 1);
            else
                gridColumn.move(0);
            prevColumn = gridColumn;
        });

        if (this.showIdTemplate)
        {
            const idColumn = this.grid.columns.find(c => c.field === "Id");
            if (idColumn)
            {
                idColumn.hidden = true;
                idColumn.move(0);
            }
        }

        this.grid.deselectAllColumns();
        this.grid.deselectAllRows();
        this.grid.clearCellSelection();
        this.grid.moving = true;
        this.restoringLayout = false;
    }

    onColumnInit(columnComponent: IgxColumnComponent): void
    {
        if (!this.columns) return;
        const self = this;
        const column = self.columns.find(x => x.Name === columnComponent.field);
        if (!column)
            return;
        self.setTemplates(columnComponent);
        self.setupSummaryColumn(column.Name);
        if (column && self.hasSummary(column.Name)) columnComponent.summaries = self.useSummary(column.IsCurrency, column.Name);

        if (!columnComponent.cellClasses)
            columnComponent.cellClasses = self.cellClasses;

    }

    getColumnDataType(column): string
    {
        return column.DataType === "nonDelineatedNumber" ? "number" : column.DataType;
    }

    setTemplates(columnComponent: IgxColumnComponent): void
    {
        if (!columnComponent.inlineEditorTemplate)
            columnComponent.inlineEditorTemplate = this.cellEditTemplate;
    }

    private columnValuesStrategyImpl(
        column: IgxColumnComponent,
        columnExprTree: IFilteringExpressionsTree,
        done: (uniqueValues: any[]) => void
    ): void
    {
        if (this.showExcelStyleSearch)
            this.getColumnData(column, columnExprTree, this.filterStrategy, uniqueValues => done(uniqueValues));
    }

    public getColumnData(
        column: IgxColumnComponent,
        columnExprTree: IFilteringExpressionsTree,
        filteringStrategy: IFilteringStrategy,
        done: (colVals: any[]) => void
    ): void
    {
        requestAnimationFrame(() =>
        {
            if (this.fetching)
                return;
            this.getDataForFilter(column.field, columnExprTree)
                .then(data =>
                {
                    const filteredData = filteringStrategy.filter(data, columnExprTree, null, null);
                    let columnValues = filteredData.map(record => record[column.field]);
                    if (column.dataType === "date")
                        columnValues = columnValues.filter((date, i, self) => self.findIndex(d => d?.getTime() === date?.getTime()) === i);
                    done([...new Set(columnValues)]);
                });
        });
    }

    getDataForFilter(columnName: string, columnExprTree: IFilteringExpressionsTree): Promise<any[]>
    {
        const column = this.columns.filter(col => col.Name === columnName)[0];
        if (!column || this.metadataServerPaging || this.showSpinner(this.columns.filter(col => col.Name === columnName)[0]))
            return null;
        const filteredColumns: string[] = columnExprTree.filteringOperands.map(f => f.fieldName);
        const colName = column["ParentPropertyName"] ? `${column["ParentPropertyName"]}.${columnName}` : columnName;
        filteredColumns.push(colName);
        const documentLookupProperty = this.viewMetadata?.GridProperties?.ClassMetadata?.Properties.filter(x => !Utilities.IsNullOrUndefinedOrEmpty(x.Lookup) && x.Lookup?.startsWith("DocumentTypeName"))[0];
        if (documentLookupProperty && columnName === documentLookupProperty.Name)
        {
            return this.$gridLoadService.loadDocumentCounts(this.$providerStorageService.LocalEntitiesStore[this.providerId], documentLookupProperty).then(_ => this.$gridLoadService
                .BuildGridRows(
                    this.$providerStorageService.LocalEntitiesStore[this.providerId],
                    this.viewMetadata,
                    this.metadataServerPaging,
                    null,
                    filteredColumns
                ))
                .then(rows =>
                {
                    this.grid.markForCheck();
                    return rows;
                });
        }
        else
        {
            return this.$gridLoadService
                .BuildGridRows(
                    this.$providerStorageService.LocalEntitiesStore[this.providerId],
                    this.viewMetadata,
                    this.metadataServerPaging,
                    null,
                    filteredColumns
                )
                .then(rows =>
                {
                    return rows;
                });
        }
    }

    editRow(event: IGridCellEventArgs): void
    {
        if(!this.viewMetadata.GridProperties.CanEdit)
        {
            return cancelEdit();
        }

        const id = event.cell?.id?.rowID;
        if (!id)
            return cancelEdit();

        const row = this.grid.data?.find(x => x.Id === id);
        if (!row)
            return cancelEdit();

        this.$gridLayoutService.SetScrollPosition(this.providerId, row, this.grid);

        if (row.FeatureAction)
        {
            this.executeFeatureAction(row);
            return cancelEdit();
        }

        if (row.Disabled || (!this.$metadataTableService.CanDo("Edit", row["$$model"], this.isViewOnly(), this.viewMetadata) && !this.isViewOnly()))
        {
            if (!this.doubleClickView)
                return cancelEdit();
        }

        if (this.isGridCellEdit)
        {
            return;
        }

        if (!this.viewMetadata.EditAction)
            this.$multipleEntityEditService.ProviderId = this.providerId;
        if (this.$gridLoadService.allowShowRecent(this.viewMetadata))
            this.$gridLoadService.addToRecentIds(this.viewMetadata.GridId, row.Id);
        if (this.useRepository)
        {
            if (this.multipleEdit && this.$providerStorageService.LocalEntitiesStore[this.providerId]?.length > 0)
                this.editMultiple(row, this.doubleClickView);
            else
                this.editSingle(row, id);
        }

        function cancelEdit(): void
        {
            if (event.event?.preventDefault)
            {
                event.event.preventDefault();
            }
        }
    }

    get doubleClickView(): boolean
    {
        return (
            this.viewMetadata.ViewOnly ||
            this.viewMetadata.EditForm?.ViewOnly ||
            this.viewMetadata.EditFormViewOnly
        ) && !this.disableViewAction && !this.$metadataViewService.IsCellEditGrid(this.viewMetadata);
    }

    executeFeatureAction(row: any): void
    {
        const self = this;
        if (self.$metadataActionService.OpenNewTabIfNeeded(row["$$model"], row.FeatureAction) === true)
            return;
        this.$metadataTableService.FetchRowModel(row, this.datacontroller, this.viewMetadata)
            .then(x => executeAction(x));
        function executeAction(model: any): void
        {
            self.$metadataActionService.ExecuteAction(model, row.FeatureAction, self.datacontroller);
        }
    }

    executeAction(row: any, action: MetadataAction): void
    {
        const self = this;
        if (self.$metadataActionService.OpenNewTabIfNeeded(row["$$model"], action) === true)
            return;
        this.$metadataTableService.FetchRowModel(row, this.datacontroller, this.viewMetadata)
            .then(x => executeAction(x));
        function executeAction(model: any): void
        {
            self.$metadataActionService.ExecuteAction(model, action, self.datacontroller);
        }
    }

    viewSingle(row: any, id: any): void
    {
        this.doRepositoryFunction("View", <RowCommandRow>{
            id: id,
            model: row["$$model"],
        });
    }

    editSingle(row: any, id: any): void
    {
        this.doRepositoryFunction("Edit", <RowCommandRow>{
            id: id,
            model: row["$$model"],
        });
    }

    editMultiple(row: any, viewOnly: boolean): void
    {
        const entities = this.$providerStorageService.LocalEntitiesStore[this.providerId].filter(e =>
            {
                const isInFilter = e["$inFilter"] && e.SerializedRowState !== "Deleted";
                const canOpen = viewOnly || this.$metadataTableService.CanDo("Edit", e, this.isViewOnly(), this.viewMetadata);
                return canOpen && isInFilter;
            });

        if (!this.viewMetadata.EditAction)
        {
            this.$multipleEntityEditService.EditableEntities = entities;
            this.$multipleEntityEditService.CurrentEditIndex = this.$multipleEntityEditService.EditableEntities.indexOf(row["$$model"]);
        }
        else
            this.$multipleEntityEditService.editActionEntity = row["$$model"];

        this.doRepositoryFunction("EditMultiple", null);
    }

    timeFormat(field: string, isDateTime: boolean = false): string
    {
        const dateFormat = isDateTime ? "MM/dd/yyyy " : "";
        return this.allowSeconds(this.getRegEx(field)) ? `${dateFormat}hh:mm:ss a` : `${dateFormat}hh:mm a`;
    }

    timeFormat24(field: string): string
    {
        return this.allowSeconds(this.getRegEx(field)) ? "HH:mm:ss" : "HH:mm";
    }

    showSpinner(column): boolean
    {
        //check if the doc type has finished loading in grid.load.service.ts
        return column.DocumentLookupType && !this.$gridLoadService.documentCountsLoaded[column.DocumentLookupType];
    }

    private getRegEx(field: string): string
    {
        return this.$gridMetadataService.getProperty(
            this.viewMetadata?.GridProperties?.ClassMetadata,
            field
        )?.Regex;
    }

    private allowSeconds(regex): boolean
    {
        if (Utilities.IsNullOrUndefined(regex))
        {
            return false;
        }
        const pattern = new RegExp(regex);
        return pattern?.test("12:00:00 AM");
    }

    addBooleanFilter(field: string, value: any): void
    {
        this.grid.filteringLogic = FilteringLogic.Or;
        this.grid.filter(field, value, IgxBooleanFilteringOperand.instance().operations[1]);
    }

    clearFilter(): void
    {
        this.grid.clearFilter();
        this.grid.filteringLogic = FilteringLogic.And;
    }

    trackByFn(_index: number, item: any): string
    {
        return item.Name;
    }

    recentLoaded: boolean = false;

    toggleHistory(showHistory: boolean): void
    {
        this.fetching = true;
        this.recentLoaded = showHistory;
        this.$providerStorageService.Refetch[this.providerId] = true;
        this.fetch(true, showHistory, true);
    }

    pinnable(column: any): boolean
    {
        return !column.AlwaysHidden && !this.grid.columns.find(x => x.field === column.Name)?.hidden;
    }

    openColumnPinning(): void
    {
        const buttons = document.getElementsByName("btnColumnPinning");
        if (!Utilities.IsNullOrUndefined(buttons))
        {
            buttons.forEach(b =>
            {
                if ((b.parentNode as HTMLElement).closest("igx-grid").id === this.providerId)
                    b.click();
            });
        }
    }

    openColumnVisibility(): void
    {
        const buttons = document.getElementsByName("btnColumnHiding");
        if (!Utilities.IsNullOrUndefined(buttons))
        {
            buttons.forEach(b =>
            {
                if ((b.parentNode as HTMLElement).closest("igx-grid").id === this.providerId)
                    b.click();
            });
        }
    }

    toolbarButtonVariant(type: string): string
    {
        switch (type)
        {
            case "visibility":
                //TODO Find a better way to determine if id is auto-hidden
                let autoHiddenId = 1;
                if (!Utilities.IsNullOrUndefined(this.columns))
                {
                    autoHiddenId = this.columns.findIndex(x => x.Name.toLowerCase() === 'id') >= 0 ? 0 : 1;
                }
                return this.grid.hiddenColumnsCount - autoHiddenId > 0 ? "tonal" : "";

            case "pinning":
                return this.grid.pinnedColumnsCount > 0 ? "tonal" : "";

            case "history":
                return this.recentLoaded ? "tonal" : "";

            default:
                return "";
        }
    }

    onKeyDown(eventArgs: KeyboardEvent): void
    {
        if ((eventArgs.key === "F10" && eventArgs.shiftKey === true))
        {
            this.onKeyUp(eventArgs);
        }

        if(!this.viewMetadata.GridProperties.CanEdit && (eventArgs.key === "Enter" || eventArgs.key === " "))
        {
            eventArgs.preventDefault();
            let cell = this.grid.selectedCells[0] as IgxGridCell;
            this.doAction(cell);
        }
    }

    onKeyUp(eventArgs: KeyboardEvent): void
    {
        if (this.cellEditing)
        {
            if(eventArgs.code === "Escape")
            {
                this.leaveCellEdit(true);
            }
            return;
        }
        const key = eventArgs["key"].toLowerCase();
        const ctrl = eventArgs["ctrlKey"];

        if(ctrl && key === "home")
        {
            this.$metadataViewService.focusFirstMetadataInput(this.viewMetadata["$$ParentView"] ? this.viewMetadata["$$ParentView"] : this.viewMetadata);
            return;
        }

        if (eventArgs.code === "ContextMenu" || (eventArgs.key === "F10" && eventArgs.shiftKey === true))
        {
            const cell = document.querySelector("igx-grid-cell.igx-grid__td--selected");

            if (cell)
            {
                eventArgs.preventDefault();
                const cellRect = cell.getBoundingClientRect();

                const event = {
                    cell: this.grid.selectedCells[0],
                    event: {
                        clientX: cellRect.x + cellRect.width / 2,
                        clientY: cellRect.y + cellRect.height / 2
                    }
                };

                this.onContextMenu(event);
            }
        }

        if (this.viewMetadata.GridProperties.CanEdit && eventArgs.code === "Enter")
        {
            const event = {
                cell: this.grid.selectedCells[0],
                event: null
            };

            this.editRow(event);
        }
    }

    onContextMenu(eventArgs: any): void
    {
        if (this.cellEditing) return;

        if (eventArgs.event.target.nodeName.toLowerCase() === "forge-icon")
            return;

        this.grid.deselectAllRows();

        if (eventArgs.event.preventDefault)
        {
            eventArgs.event.preventDefault();
        }

        const gridBody = document.querySelector(".igx-grid__tbody-content");

        let openPopovers = gridBody.querySelectorAll("forge-popover.grid-action-popover");
        for (let i = 0, l = openPopovers.length; i < l; i++)
        {
            gridBody.removeChild(openPopovers[i]);
        }

        const popover = document.createElement("forge-popover");
        popover.classList.add("grid-action-popover");
        popover.noAnchor = true;
        popover.positionStrategy = "absolute";
        popover.setAttribute("preset", "list");

        // Menu
        const menu = document.createElement("forge-menu");
        popover.appendChild(menu);

        // List
        const optionList = document.createElement("forge-list");
        optionList.dense = true;
        optionList.setAttribute("role", "menu");

        menu.appendChild(optionList);

        const row = eventArgs.cell.row.data;
        const id = row.Id;
        const self = this;

        let actionCount = 0;

        const executeFeature = (): void =>
        {
            self.executeFeatureAction(row);
        };

        let featureActionButton = null;
        let featureActionListItem = null;
        if (this.hasFeatureAction(row))
        {
            featureActionButton = document.createElement("button");
            featureActionButton.type = "button";
            featureActionButton.innerText = row.FeatureAction.Caption;
            featureActionButton.setAttribute("role", "menuitem");
            featureActionButton.addEventListener("click", executeFeature);
            self.contextMenuHandlers.set(featureActionButton, executeFeature);

            const featureActionListItemHandler = () => closePopover();
            featureActionListItem = document.createElement("forge-list-item");
            featureActionListItem.addEventListener("click", featureActionListItemHandler);
            self.contextMenuHandlers.set(featureActionListItem, featureActionListItemHandler);
            featureActionListItem.setAttribute("role", "presentation");
            featureActionListItem.setAttribute("focus-propagation", "off");

            featureActionListItem.appendChild(featureActionButton);
            optionList.appendChild(featureActionListItem);
            actionCount++;
        }

        const editRow = (): void =>
        {
            self.editSingle(row, id);
        };

        let viewButton = null;
        let viewListItem = null;
        if (this.isViewOnly() && !this.disableViewAction)
        {
            viewButton = document.createElement("button");
            viewButton.type = "button";
            viewButton.innerText = "View";
            viewButton.addEventListener("click", editRow);
            self.contextMenuHandlers.set(viewButton, editRow);

            const viewListItemHandler = () => closePopover();
            viewListItem = document.createElement("forge-list-item");
            viewListItem.addEventListener("click", viewListItemHandler);
            self.contextMenuHandlers.set(viewListItem, viewListItemHandler);
            viewListItem.setAttribute("role", "presentation");
            viewListItem.setAttribute("focus-propagation", "off");

            viewListItem.appendChild(viewButton);
            optionList.appendChild(viewListItem);
            actionCount++;
        }

        let editButton = null;
        let editListItem = null;
        if (this.$metadataTableService.CanDo("Edit", row["$$model"], this.isViewOnly(), this.viewMetadata))
        {
            editButton = document.createElement("button");
            editButton.type = "button";
            editButton.innerText = "Edit";
            editButton.addEventListener("click", editRow);
            self.contextMenuHandlers.set(editButton, editRow);

            const editListItemHandler = () => closePopover();
            editListItem = document.createElement("forge-list-item");
            editListItem.addEventListener("click", editListItemHandler);
            self.contextMenuHandlers.set(editListItem, editListItemHandler);
            editListItem.setAttribute("role", "presentation");
            editListItem.setAttribute("focus-propagation", "off");

            editListItem.appendChild(editButton);
            optionList.appendChild(editListItem);
            actionCount++;
        }

        const deleteRow = (): void =>
        {
            const msg = [
                "Are you sure you want to delete ",
                row["$$model"]
                    ? row["$$model"]["MetadataFormTitle"]
                        ? row["$$model"]["MetadataFormTitle"]
                        : "this item"
                    : "this item",
                "?",
            ].join("");

            self.$commonDialogsService.showConfirmationMessage(msg, "Delete Item")
                .then(() =>
                {
                    if (self.useRepository)
                    {
                        row["$$Deleting"] = true;
                        self.doRepositoryFunction("Delete", { id: id, model: row["$$model"] });
                    }
                });
        };

        let deleteButton = null;
        let deleteListItem = null;
        if (this.$metadataTableService.CanDo("Delete", row["$$model"], this.isViewOnly(), this.viewMetadata))
        {
            deleteButton = document.createElement("button");
            deleteButton.type = "button";
            deleteButton.innerText = "Delete";
            deleteButton.addEventListener("click", deleteRow);
            self.contextMenuHandlers.set(deleteButton, deleteRow);

            const deleteListItemHandler = () => closePopover();
            deleteListItem = document.createElement("forge-list-item");
            deleteListItem.addEventListener("click", deleteListItemHandler);
            self.contextMenuHandlers.set(deleteListItem, deleteListItemHandler);
            deleteListItem.setAttribute("role", "presentation");
            deleteListItem.setAttribute("focus-propagation", "off");

            deleteListItem.appendChild(deleteButton);
            optionList.appendChild(deleteListItem);
            actionCount++;
        }

        const primaryActions = row.Commands.filter(x => x.Primary && !x.Hidden);
        primaryActions.forEach(action =>
        {
            const button = document.createElement("button");
            button.type = "button";
            button.innerText = action.Caption;
            const buttonHandler = () => self.executeAction(row, action);
            button.addEventListener("click", buttonHandler);
            self.contextMenuHandlers.set(button, buttonHandler);

            const listItem = document.createElement("forge-list-item");
            const listItemHandler = () => closePopover();
            listItem.addEventListener("click", listItemHandler);
            self.contextMenuHandlers.set(listItem, listItemHandler);
            listItem.setAttribute("role", "presentation");
            listItem.setAttribute("focus-propagation", "off");

            listItem.appendChild(button);
            optionList.appendChild(listItem);
            actionCount++;

            self.$gridSelectionService.SetSelectedIds(self.providerId, [id]);
        });

        const overflowActions = row.Commands.filter(x => !x.Primary && !x.Hidden);
        overflowActions.forEach(action =>
        {
            const button = document.createElement("button");
            button.type = "button";
            button.innerText = action.Caption;

            let buttonHandler: EventListener;
            if (action.Caption === "Copy")
            {
                buttonHandler = () =>
                {
                    this.doRepositoryFunction("Copy", <RowCommandRow>{
                        id: id,
                        model: row["$$model"],
                    });
                };
            }
            else
            {
                buttonHandler = () => self.executeAction(row, action);
            }
            button.addEventListener("click", buttonHandler);
            self.contextMenuHandlers.set(button, buttonHandler);

            const listItem = document.createElement("forge-list-item");
            const listItemHandler = () => closePopover();
            listItem.addEventListener("click", listItemHandler);
            self.contextMenuHandlers.set(listItem, listItemHandler);
            listItem.setAttribute("role", "presentation");
            listItem.setAttribute("focus-propagation", "off");

            listItem.appendChild(button);
            optionList.appendChild(listItem);
            actionCount++;

            self.$gridSelectionService.SetSelectedIds(self.providerId, [id]);
        });

        const focusableElements = optionList.querySelectorAll("forge-list-item button");
        const focusableCount = focusableElements.length;
        let currentIndex = 0;

        const navigateList = (event: KeyboardEvent): void =>
        {
            let key = event.key;

            if (key === "Tab")
            {
                event.preventDefault();
                event.stopImmediatePropagation();
                closePopover();
                return;
            }

            if (key === "ArrowUp")
            {
                currentIndex--;
                if (currentIndex < 0)
                {
                    currentIndex = focusableCount - 1;
                }
            }

            if (key === "ArrowDown")
            {
                currentIndex++;
                if (currentIndex > focusableCount - 1)
                {
                    currentIndex = 0;
                }
            }

            (focusableElements[currentIndex] as HTMLElement).focus();
        };

        const closePopover = (): void =>
        {
            const allButtons = popover.querySelectorAll("button");
            allButtons.forEach(btn =>
            {
                const handler = self.contextMenuHandlers.get(btn);
                if (handler)
                {
                    btn.removeEventListener("click", handler);
                    self.contextMenuHandlers.delete(btn);
                }
            });

            const allListItems = popover.querySelectorAll("forge-list-item");
            allListItems.forEach(item =>
            {
                const handler = self.contextMenuHandlers.get(item as HTMLElement);
                if (handler)
                {
                    (item as HTMLElement).removeEventListener("click", handler);
                    self.contextMenuHandlers.delete(item as HTMLElement);
                }
            });

            optionList.removeEventListener("keydown", navigateList);
            popover.removeEventListener("forge-popover-toggle", closePopover);

            popover.open = false;
            eventArgs.cell.row.selected = false;
            self.$gridSelectionService.SetSelectedIds(self.providerId, []);
        };

        if (actionCount > 0)
        {
            optionList.addEventListener("keydown", navigateList);
            eventArgs.cell.row.selected = true;
            gridBody.appendChild(popover);

            popover.open = true;
            popover.addEventListener("forge-popover-toggle", closePopover);

            const overlay = popover.shadowRoot.querySelector("forge-overlay").shadowRoot.querySelector(".forge-overlay") as HTMLElement;
            overlay.style.margin = "0";
            overlay.style.marginInlineStart = "0";
            overlay.style.marginInlineEnd = "0";
            overlay.style.marginBlockStart = "0";
            overlay.style.marginBlockEnd = "0";
            overlay.style.translate = `${eventArgs.event.clientX}px ${eventArgs.event.clientY}px`;

            (popover.querySelector("forge-list forge-list-item button") as HTMLElement).focus();
        }
    }

    hasFeatureAction(row: any): boolean
    {
        return !Utilities.IsNullOrUndefined(row?.FeatureAction) && !row.FeatureAction.Hidden;
    }

    columnPinned(event: IPinColumnEventArgs): void
    {
        this.saveGridState(true);
    }

    activeNodeChange(event: IActiveNodeChangeEventArgs): void
    {
        const self = this;
        if (Utilities.IsNullOrUndefined(event))
        {
            this.grid.visibleColumns.forEach(column =>
            {
                let headerIconContainers = this.grid.nativeElement.querySelectorAll(".igx-grid-thead__item .igx-grid-th__icons");

                if (headerIconContainers)
                {
                    const headerIconContainer = headerIconContainers[column.visibleIndex];
                    if (headerIconContainer)
                    {
                        let sort = headerIconContainer.querySelector(".sort-icon");
                        sort?.removeEventListener("keydown", this.mimicIconButtonPressed);

                        let filter = headerIconContainer.querySelector(".grid-filter-icon")?.parentElement;
                        filter?.removeEventListener("keydown",this. mimicIconButtonPressed);
                    }
                }
            });

            return;
        }

        removeTabstops();

        if (event?.tag === "headerCell")
        {
            const headerIconContainers = this.grid.nativeElement.querySelectorAll(".igx-grid-thead__item .igx-grid-th__icons");
            let headerIconContainer = null;
            const headerColumn = this.grid.visibleColumns[event.column];

            headerIconContainers.forEach(header =>
            {
                if ((header.previousElementSibling.children[0] as HTMLElement).title === headerColumn.header)
                {
                    headerIconContainer = header;
                    return;
                }
            });

            if (headerIconContainer)
            {
                if (headerColumn.sortable === true)
                {
                    let sort = headerIconContainer.querySelector(".sort-icon");
                    if (sort)
                    {
                        sort.setAttribute("tabindex", "0");
                        sort.setAttribute("role", "button");
                        sort.setAttribute("aria-label", `sort ${headerColumn.header}`);
                        sort.addEventListener("keydown", this.mimicIconButtonPressed);
                    }
                }

                if (headerColumn.filterable === true)
                {
                    let filter = headerIconContainer.querySelector(".grid-filter-icon").parentElement;
                    if (filter)
                    {
                        filter.setAttribute("tabindex", "0");
                        filter.setAttribute("role", "button");
                        filter.setAttribute("aria-label", `filter ${headerColumn.header}`);
                        filter.addEventListener("keydown", this.mimicIconButtonPressed);
                    }
                }

                let selector = headerIconContainer.parentElement.querySelector(".column-move-selector");
                selector.setAttribute("tabindex", "0");
                selector.setAttribute("role", "region");
                selector.addEventListener("keydown", this.mimicIconButtonPressed);
            }
        }

        function removeTabstops(): void
        {
            let headerCells = document.querySelectorAll(".igx-grid-thead__item .igx-grid-th__icons");
            headerCells.forEach(x =>
            {
                let el = x.querySelector(".sort-icon");
                el?.removeAttribute("tabindex");
                el?.removeAttribute("role");
                el?.removeAttribute("aria-label");
                el?.removeEventListener("keydown", self.mimicIconButtonPressed);

                el = x.querySelector(".grid-filter-icon");
                el?.parentElement?.removeAttribute("tabindex");
                el?.parentElement?.removeAttribute("role");
                el?.parentElement?.removeAttribute("aria-label");
                el?.removeAttribute("aria-label");
                el?.removeEventListener("keydown", self.mimicIconButtonPressed);

                let selector = x.parentElement.querySelector(".column-move-selector");
                selector.removeAttribute("tabindex");
                selector.removeAttribute("role");
                selector.removeEventListener("keydown", self.mimicIconButtonPressed);
            });
        }
    }

    mimicIconButtonPressed(event: KeyboardEvent): void
    {
        if (event.key === "Enter" || event.key === " ")
        {
            (event.target as HTMLElement).click();
            event.preventDefault();
            event.stopImmediatePropagation();
        }
    }
}
